var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/overview/TotalPrice") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "States-&-Styles-&-Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets---Icons",
    transform: "translate(-176.000000, -552.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/overview/price",
    transform: "translate(176.000000, 552.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-985"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,0 C13.432,0 0,13.432 0,30 C0,46.568 13.432,60 30,60 C46.568,60 60,46.568 60,30 C60,13.432 46.568,0 30,0 M30,2 C45.439,2 58,14.561 58,30 C58,45.439 45.439,58 30,58 C14.561,58 2,45.439 2,30 C2,14.561 14.561,2 30,2",
    id: "Fill-1",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5723,43.0693 C41.6093,42.9383 41.6333,42.8063 41.6333,42.6723 L41.6333,42.5813 C41.5943,42.7493 41.5323,42.9113 41.4573,43.0693 L41.5723,43.0693 Z",
    id: "Fill-3",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.665,36.9863 L16.665,36.1113 C16.665,36.4133 16.787,36.7053 16.997,36.9863 L17.463,36.9863 C17.463,37.0523 17.496,37.1283 17.543,37.2073 L17.543,36.3383 C17.981,35.7563 20.289,34.6513 24.361,34.1643 C24.236,33.8743 24.152,33.5723 24.152,33.2483 L24.294,33.2483 C24.258,33.1173 24.233,32.9853 24.233,32.8513 C24.181,32.6573 24.152,32.4563 24.152,32.2483 L24.233,32.2483 L24.233,32.1713 C19.174,32.7593 15.543,34.3383 15.543,36.1993 L15.543,36.9863 L16.665,36.9863 Z",
    id: "Fill-5",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.543,42.6714 L15.543,42.6724 C15.543,42.8064 15.567,42.9384 15.605,43.0694 L15.706,43.0694 C15.644,42.9394 15.581,42.8094 15.543,42.6714",
    id: "Fill-7",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4805,39.1636 L40.4805,42.0696 L41.6325,42.0696 L41.6325,38.5186 L41.6325,37.7876 C41.6005,37.7916 41.5665,37.7946 41.5345,37.7986 C41.3425,38.3026 40.9885,38.7586 40.4805,39.1636",
    id: "Fill-9",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.665,39.1504 C16.095,38.6924 15.702,38.1734 15.543,37.5884 L15.543,42.0694 L16.665,42.0694 L16.665,39.1504 Z",
    id: "Fill-11",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3115,41.1616 L35.3115,44.1956 C36.6965,43.8886 37.7505,43.5096 38.4825,43.1406 L38.4825,40.2656 C37.5575,40.6336 36.4805,40.9306 35.3115,41.1616",
    id: "Fill-13",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3115,44.3931 L34.3115,41.3411 C33.2935,41.5031 32.2245,41.6181 31.1405,41.6881 L31.1405,44.7711 C32.3185,44.6911 33.3745,44.5591 34.3115,44.3931",
    id: "Fill-15",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7979,44.1836 L21.7979,41.1516 C20.6259,40.9176 19.5499,40.6146 18.6269,40.2426 L18.6269,43.1156 C19.3509,43.4876 20.4069,43.8716 21.7979,44.1836",
    id: "Fill-17",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9688,44.7676 L25.9688,41.6846 C24.8838,41.6126 23.8148,41.4976 22.7978,41.3336 L22.7978,44.3846 C23.7348,44.5516 24.7908,44.6856 25.9688,44.7676",
    id: "Fill-19",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5811,44.8555 C29.1221,44.8555 29.6381,44.8415 30.1411,44.8215 L30.1411,41.7385 C29.6201,41.7585 29.1001,41.7725 28.5811,41.7725 C28.0451,41.7725 27.5071,41.7585 26.9691,41.7365 L26.9691,44.8195 C27.4881,44.8405 28.0201,44.8555 28.5811,44.8555",
    id: "Fill-21",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.627,42.4102 L17.627,39.7702 C17.599,39.7552 17.571,39.7402 17.543,39.7242 L17.543,42.2902 C17.567,42.3292 17.592,42.3682 17.627,42.4102",
    id: "Fill-23",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4824,42.4668 C39.5474,42.3978 39.5984,42.3328 39.6324,42.2708 L39.6324,39.7168 C39.5844,39.7438 39.5334,39.7718 39.4824,39.7998 L39.4824,42.4668 Z",
    id: "Fill-25",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6328,42.2705 C39.6738,42.1985 39.6998,42.1305 39.6998,42.0695 L40.4808,42.0695 L40.4808,39.1635 C40.2328,39.3605 39.9438,39.5425 39.6328,39.7165 L39.6328,42.2705 Z",
    id: "Fill-27",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.543,42.29 L17.543,39.724 C17.221,39.544 16.92,39.355 16.665,39.15 L16.665,42.069 L17.463,42.069 C17.463,42.136 17.496,42.211 17.543,42.29",
    id: "Fill-29",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.665,36.1113 L16.665,36.9863 L16.997,36.9863 C16.787,36.7053 16.665,36.4133 16.665,36.1113",
    id: "Fill-31",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.627,37.4043 L17.702,37.4043 C17.894,37.5983 18.199,37.8123 18.627,38.0323 L18.627,37.4043 Z",
    id: "Fill-33",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.627,46.0806 L18.066,46.0806 C17.912,46.0076 17.77,45.9306 17.627,45.8526 L17.627,46.0806 Z",
    id: "Fill-35",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.627,43.1152 L18.627,40.2422 C18.267,40.0962 17.936,39.9372 17.627,39.7702 L17.627,42.4102 C17.808,42.6232 18.143,42.8652 18.627,43.1152",
    id: "Fill-37",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7979,37.4043 L21.7979,37.4043 L21.7979,39.1003 C22.1139,39.1723 22.4469,39.2393 22.7979,39.3013 L22.7979,37.4043 Z",
    id: "Fill-39",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7979,41.3335 C22.4579,41.2785 22.1249,41.2175 21.7979,41.1515 L21.7979,44.1835 C22.1139,44.2545 22.4469,44.3215 22.7979,44.3845 L22.7979,41.3335 Z",
    id: "Fill-41",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9688,37.4043 L25.9688,37.4043 L25.9688,39.6853 C26.2908,39.7073 26.6288,39.7223 26.9688,39.7373 L26.9688,37.4043 Z",
    id: "Fill-43",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9688,44.8193 L26.9688,41.7363 C26.6348,41.7223 26.3008,41.7063 25.9688,41.6843 L25.9688,44.7673 C26.2908,44.7903 26.6288,44.8053 26.9688,44.8193",
    id: "Fill-45",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1406,37.5342 C30.9036,37.4922 30.6656,37.4512 30.4356,37.4042 L30.1406,37.4042 L30.1406,39.7392 C30.4816,39.7252 30.8186,39.7102 31.1406,39.6882 L31.1406,37.5342 Z",
    id: "Fill-47",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1406,44.771 L31.1406,41.688 C30.8086,41.71 30.4746,41.726 30.1406,41.739 L30.1406,44.822 C30.4816,44.808 30.8186,44.793 31.1406,44.771",
    id: "Fill-49",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3115,39.1133 L35.3115,37.9823 C34.9765,37.9663 34.6435,37.9453 34.3115,37.9203 L34.3115,39.3103 C34.6605,39.2493 34.9965,39.1833 35.3115,39.1133",
    id: "Fill-51",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3115,44.3931 C34.6605,44.3311 34.9965,44.2661 35.3115,44.1961 L35.3115,41.1621 C34.9845,41.2261 34.6515,41.2871 34.3115,41.3411 L34.3115,44.3931 Z",
    id: "Fill-53",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5781,38.0117 C38.5471,38.0127 38.5151,38.0147 38.4821,38.0157 L38.4821,38.0577 C38.5131,38.0427 38.5491,38.0277 38.5781,38.0117",
    id: "Fill-55",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4824,46.0806 L39.4824,45.8826 C39.3564,45.9496 39.2314,46.0176 39.0964,46.0806 L39.4824,46.0806 Z",
    id: "Fill-57",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4824,43.1406 C38.9514,42.9046 39.2864,42.6736 39.4824,42.4666 L39.4824,39.7996 C39.1714,39.9646 38.8424,40.1216 38.4824,40.2656 L38.4824,43.1406 Z",
    id: "Fill-59",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7979,39.2236 L21.7979,39.1006 C20.4069,38.7876 19.3509,38.4046 18.6269,38.0326 L18.6269,38.1906 C19.4669,38.5966 20.5449,38.9466 21.7979,39.2236",
    id: "Fill-61",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9688,39.8042 L25.9688,39.6852 C24.7908,39.6032 23.7348,39.4692 22.7978,39.3022 L22.7978,39.4222 C23.7788,39.5952 24.8438,39.7242 25.9688,39.8042",
    id: "Fill-63",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3115,39.1133 L35.3115,39.2323 C36.5615,38.9583 37.6395,38.6113 38.4825,38.2093 L38.4825,38.0583 C37.7505,38.4273 36.6965,38.8053 35.3115,39.1133",
    id: "Fill-65",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5723,39.8979 C29.1053,39.8979 29.6263,39.8829 30.1403,39.8609 L30.1403,39.7389 C29.6373,39.7589 29.1223,39.7729 28.5813,39.7729 C28.0203,39.7729 27.4883,39.7579 26.9683,39.7369 L26.9683,39.8589 C27.4943,39.8819 28.0273,39.8979 28.5723,39.8979",
    id: "Fill-67",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.627,37.6025 L17.627,37.4045 L17.702,37.4045 C17.635,37.3355 17.581,37.2695 17.543,37.2065 L17.543,37.5355 C17.572,37.5585 17.598,37.5805 17.627,37.6025",
    id: "Fill-69",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3115,39.3105 C33.3745,39.4765 32.3185,39.6085 31.1405,39.6885 L31.1405,39.8075 C32.2655,39.7285 33.3315,39.6005 34.3115,39.4285 L34.3115,39.3105 Z",
    id: "Fill-71",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.665,39.1504 L16.665,36.9864 L15.543,36.9864 L15.543,37.5884 C15.702,38.1734 16.095,38.6924 16.665,39.1504",
    id: "Fill-73",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4805,39.1636 C40.9885,38.7586 41.3425,38.3026 41.5345,37.7986 C41.1855,37.8376 40.8345,37.8716 40.4805,37.9016 L40.4805,39.1636 Z",
    id: "Fill-75",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.543,37.5356 L17.543,37.2066 C17.496,37.1276 17.463,37.0526 17.463,36.9866 L16.997,36.9866 C17.138,37.1756 17.317,37.3586 17.543,37.5356",
    id: "Fill-77",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3115,41.1616 C36.4805,40.9306 37.5575,40.6336 38.4825,40.2656 L38.4825,38.2096 C37.6395,38.6116 36.5615,38.9576 35.3115,39.2316 L35.3115,41.1616 Z",
    id: "Fill-79",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5811,41.7729 C29.1001,41.7729 29.6201,41.7589 30.1411,41.7389 L30.1411,39.8609 C29.6261,39.8829 29.1051,39.8979 28.5721,39.8979 C28.0271,39.8979 27.4941,39.8819 26.9691,39.8589 L26.9691,41.7359 C27.5071,41.7579 28.0451,41.7729 28.5811,41.7729",
    id: "Fill-81",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3115,41.3413 L34.3115,39.4283 C33.3315,39.6003 32.2655,39.7283 31.1405,39.8073 L31.1405,41.6883 C32.2245,41.6183 33.2935,41.5033 34.3115,41.3413",
    id: "Fill-83",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.627,37.6025 C17.598,37.5805 17.572,37.5585 17.543,37.5355 L17.543,39.7245 C17.571,39.7395 17.599,39.7545 17.627,39.7695 L17.627,37.6025 Z",
    id: "Fill-85",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4824,39.7993 C39.5334,39.7723 39.5844,39.7443 39.6324,39.7163 L39.6324,37.9653 C39.5834,37.9673 39.5324,37.9683 39.4824,37.9713 L39.4824,39.7993 Z",
    id: "Fill-87",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9688,41.6846 L25.9688,39.8046 C24.8438,39.7246 23.7788,39.5946 22.7978,39.4216 L22.7978,41.3336 C23.8148,41.4976 24.8838,41.6126 25.9688,41.6846",
    id: "Fill-89",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7979,39.2236 C20.5449,38.9466 19.4669,38.5966 18.6269,38.1906 L18.6269,40.2426 C19.5499,40.6146 20.6259,40.9176 21.7979,41.1516 L21.7979,39.2236 Z",
    id: "Fill-91",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.543,39.7241 L17.543,37.5361 C17.317,37.3591 17.138,37.1751 16.997,36.9861 L16.665,36.9861 L16.665,39.1501 C16.92,39.3551 17.221,39.5441 17.543,39.7241",
    id: "Fill-93",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6328,37.9648 L39.6328,39.7168 C39.9438,39.5428 40.2328,39.3608 40.4808,39.1638 L40.4808,37.9018 C40.1978,37.9238 39.9168,37.9478 39.6328,37.9648",
    id: "Fill-95",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.627,38.0322 C18.199,37.8122 17.894,37.5982 17.702,37.4042 L17.627,37.4042 L17.627,37.6022 C17.905,37.8092 18.242,38.0052 18.627,38.1912 L18.627,38.0322 Z",
    id: "Fill-97",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.627,40.2422 L18.627,38.1912 C18.242,38.0052 17.905,37.8092 17.627,37.6022 L17.627,39.7702 C17.936,39.9372 18.267,40.0962 18.627,40.2422",
    id: "Fill-99",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7979,39.4219 L22.7979,39.3019 C22.4469,39.2389 22.1139,39.1719 21.7979,39.1009 L21.7979,39.2239 C22.1199,39.2949 22.4529,39.3609 22.7979,39.4219",
    id: "Fill-101",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7979,41.3335 L22.7979,39.4215 C22.4529,39.3605 22.1199,39.2945 21.7979,39.2235 L21.7979,41.1515 C22.1249,41.2175 22.4579,41.2785 22.7979,41.3335",
    id: "Fill-103",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9688,39.8594 L26.9688,39.7364 C26.6288,39.7224 26.2908,39.7074 25.9688,39.6854 L25.9688,39.8044 C26.2968,39.8274 26.6308,39.8454 26.9688,39.8594",
    id: "Fill-105",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9688,41.7363 L26.9688,39.8593 C26.6308,39.8453 26.2968,39.8273 25.9688,39.8043 L25.9688,41.6843 C26.3008,41.7063 26.6348,41.7223 26.9688,41.7363",
    id: "Fill-107",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1406,39.8071 L31.1406,39.6881 C30.8186,39.7101 30.4816,39.7251 30.1406,39.7391 L30.1406,39.8611 C30.4786,39.8471 30.8126,39.8301 31.1406,39.8071",
    id: "Fill-109",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1406,41.6885 L31.1406,39.8075 C30.8126,39.8305 30.4786,39.8475 30.1406,39.8615 L30.1406,41.7385 C30.4746,41.7255 30.8086,41.7095 31.1406,41.6885",
    id: "Fill-111",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3115,39.1133 C34.9965,39.1833 34.6605,39.2493 34.3115,39.3103 L34.3115,39.4283 C34.6565,39.3683 34.9895,39.3023 35.3115,39.2323 L35.3115,39.1133 Z",
    id: "Fill-113",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3115,39.4287 L34.3115,41.3417 C34.6515,41.2867 34.9845,41.2267 35.3115,41.1617 L35.3115,39.2317 C34.9895,39.3027 34.6565,39.3677 34.3115,39.4287",
    id: "Fill-115",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4824,38.2095 C38.6264,38.1415 38.7564,38.0695 38.8864,37.9985 C38.7844,38.0015 38.6814,38.0085 38.5784,38.0115 C38.5484,38.0275 38.5124,38.0425 38.4824,38.0585 L38.4824,38.2095 Z",
    id: "Fill-117",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4824,38.2095 L38.4824,40.2655 C38.8424,40.1215 39.1714,39.9645 39.4824,39.7995 L39.4824,37.9715 C39.2844,37.9825 39.0854,37.9905 38.8864,37.9985 C38.7564,38.0695 38.6264,38.1415 38.4824,38.2095",
    id: "Fill-119",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5723,43.0693 C41.3713,43.7863 40.6293,44.4513 39.4823,45.0223 L39.4823,45.8823 C40.6383,45.2673 41.4223,44.5043 41.6333,43.5813 L41.6333,43.0693 L41.5723,43.0693 Z",
    id: "Fill-121",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4824,45.4551 C36.0894,46.3691 32.5484,46.9501 28.5874,46.9501 C24.5914,46.9501 21.0194,46.3591 18.6274,45.4311 L18.6274,46.0801 L18.0664,46.0801 C20.6224,47.2851 24.6894,47.8551 28.5814,47.8551 C32.4724,47.8551 36.5414,47.2851 39.0964,46.0801 L38.4824,46.0801 L38.4824,45.4551 Z",
    id: "Fill-123",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6045,43.0693 L15.5425,43.0693 L15.5425,43.6713 C15.7795,44.5403 16.5375,45.2623 17.6265,45.8533 L17.6265,44.9863 C16.5205,44.4233 15.8015,43.7713 15.6045,43.0693",
    id: "Fill-125",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7061,43.0693 L15.6041,43.0693 C15.8021,43.7713 16.5201,44.4233 17.6271,44.9863 L17.6271,44.8533 C16.7091,44.3563 16.0371,43.7633 15.7061,43.0693",
    id: "Fill-127",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5811,46.8555 C24.9631,46.8555 21.1931,46.3615 18.6271,45.3245 L18.6271,45.4305 C21.0191,46.3585 24.5921,46.9495 28.5881,46.9495 C32.5491,46.9495 36.0901,46.3685 38.4821,45.4555 L38.4821,45.3485 C35.9171,46.3695 32.1731,46.8555 28.5811,46.8555",
    id: "Fill-129",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4824,44.8823 L39.4824,45.0223 C40.6284,44.4513 41.3714,43.7863 41.5724,43.0693 L41.4574,43.0693 C41.1194,43.7773 40.4274,44.3793 39.4824,44.8823",
    id: "Fill-131",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.627,45.4307 C18.265,45.2897 17.933,45.1407 17.627,44.9857 L17.627,45.8527 C17.77,45.9307 17.912,46.0077 18.066,46.0807 L18.627,46.0807 L18.627,45.4307 Z",
    id: "Fill-133",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.627,44.853 L17.627,44.986 C17.933,45.141 18.265,45.29 18.627,45.431 L18.627,45.325 C18.267,45.179 17.936,45.02 17.627,44.853",
    id: "Fill-135",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4824,45.4551 L38.4824,46.0801 L39.0964,46.0801 C39.2314,46.0171 39.3564,45.9491 39.4824,45.8821 L39.4824,45.0221 C39.1774,45.1741 38.8414,45.3181 38.4824,45.4551",
    id: "Fill-137",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4824,45.3481 L38.4824,45.4551 C38.8414,45.3181 39.1774,45.1741 39.4824,45.0221 L39.4824,44.8821 C39.1714,45.0471 38.8424,45.2041 38.4824,45.3481",
    id: "Fill-139",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5957,45.6372 C33.2047,45.5682 33.7797,45.4872 34.3117,45.3932 L34.3117,45.2402 C33.7277,45.3972 33.1577,45.5252 32.5957,45.6372",
    id: "Fill-141",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.665,43.2041 C39.604,43.2341 39.543,43.2661 39.482,43.2941 L39.482,43.4671 C39.571,43.3731 39.632,43.2851 39.665,43.2041",
    id: "Fill-143",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9365,43.0693 L41.4575,43.0693 C41.5325,42.9113 41.5945,42.7493 41.6325,42.5813 L41.6325,42.0693 L40.4805,42.0693 L40.4805,42.7993 C40.2965,42.8953 40.1185,42.9783 39.9365,43.0693",
    id: "Fill-145",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.665,43.0693 L16.665,42.0693 L15.543,42.0693 L15.543,42.6713 C15.581,42.8093 15.644,42.9393 15.706,43.0693 L16.665,43.0693 Z",
    id: "Fill-147",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3115,45.1958 C36.6965,44.8878 37.7505,44.5098 38.4825,44.1408 L38.4825,43.7528 C37.3975,44.2308 36.3375,44.6288 35.3115,44.9478 L35.3115,45.1958 Z",
    id: "Fill-149",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9688,44.8193 L26.9688,44.9123 C27.4898,44.9343 28.0258,44.9493 28.5878,44.9493 C29.1268,44.9493 29.6398,44.9353 30.1408,44.9153 L30.1408,44.8213 C29.6378,44.8413 29.1218,44.8553 28.5808,44.8553 C28.0208,44.8553 27.4888,44.8403 26.9688,44.8193",
    id: "Fill-151",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3115,44.2939 C36.6905,43.9939 37.7495,43.6319 38.4825,43.2899 L38.4825,43.1409 C37.7505,43.5099 36.6965,43.8879 35.3115,44.1959 L35.3115,44.2939 Z",
    id: "Fill-153",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4824,42.4668 L39.4824,42.6908 C39.5454,42.6348 39.5964,42.5818 39.6324,42.5328 L39.6324,42.2708 C39.5984,42.3328 39.5474,42.3978 39.4824,42.4668",
    id: "Fill-155",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7979,44.3843 L22.7979,44.4773 C23.7349,44.6423 24.7899,44.7763 25.9689,44.8583 L25.9689,44.7673 C24.7909,44.6863 23.7349,44.5513 22.7979,44.3843",
    id: "Fill-157",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1406,44.771 L31.1406,44.864 C32.3186,44.784 33.3726,44.652 34.3116,44.489 L34.3116,44.393 C33.3736,44.559 32.3186,44.691 31.1406,44.771",
    id: "Fill-159",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7979,44.1836 C20.4069,43.8716 19.3509,43.4876 18.6269,43.1156 L18.6269,43.2596 C19.3499,43.6046 20.4109,43.9736 21.7979,44.2796 L21.7979,44.1836 Z",
    id: "Fill-161",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.543,42.29 L17.543,42.533 C17.564,42.561 17.598,42.592 17.627,42.622 L17.627,42.41 C17.592,42.368 17.567,42.329 17.543,42.29",
    id: "Fill-163",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5879,44.9497 C28.0259,44.9497 27.4899,44.9337 26.9689,44.9127 L26.9689,45.8197 C27.4879,45.8407 28.0209,45.8557 28.5809,45.8557 C29.1219,45.8557 29.6379,45.8417 30.1409,45.8217 L30.1409,44.9157 C29.6399,44.9357 29.1269,44.9497 28.5879,44.9497",
    id: "Fill-165",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.627,43.4102 L17.627,42.6212 C17.598,42.5922 17.565,42.5612 17.543,42.5332 L17.543,42.2902 C17.496,42.2112 17.463,42.1362 17.463,42.0692 L16.665,42.0692 L16.665,43.0692 L17.463,43.0692 C17.463,43.1682 17.521,43.2842 17.627,43.4102",
    id: "Fill-167",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7979,44.4771 L22.7979,45.3841 C23.7349,45.5521 24.7909,45.6861 25.9689,45.7681 L25.9689,44.8581 C24.7899,44.7761 23.7349,44.6431 22.7979,44.4771",
    id: "Fill-169",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3115,44.4893 C33.3735,44.6523 32.3185,44.7843 31.1405,44.8643 L31.1405,45.7713 C31.6505,45.7373 32.1305,45.6903 32.5955,45.6373 C33.1575,45.5253 33.7275,45.3973 34.3115,45.2393 L34.3115,44.4893 Z",
    id: "Fill-171",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.627,43.2598 L18.627,44.1148 C19.351,44.4878 20.407,44.8708 21.798,45.1838 L21.798,44.2798 C20.411,43.9738 19.35,43.6048 18.627,43.2598",
    id: "Fill-173",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6328,42.2705 L39.6328,42.5335 C39.5968,42.5825 39.5458,42.6355 39.4828,42.6905 L39.4828,43.2945 C39.5428,43.2655 39.6048,43.2335 39.6648,43.2045 C39.6838,43.1575 39.6998,43.1105 39.6998,43.0695 L39.9368,43.0695 C40.1178,42.9785 40.2968,42.8955 40.4808,42.7995 L40.4808,42.0695 L39.6998,42.0695 C39.6998,42.1305 39.6738,42.1985 39.6328,42.2705",
    id: "Fill-175",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3115,44.9478 C36.3375,44.6288 37.3975,44.2308 38.4825,43.7528 L38.4825,43.2898 C37.7495,43.6328 36.6905,43.9938 35.3115,44.2938 L35.3115,44.9478 Z",
    id: "Fill-177",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.627,43.2598 L18.627,43.1148 C18.143,42.8658 17.808,42.6228 17.627,42.4098 L17.627,42.6218 C17.806,42.8048 18.137,43.0258 18.627,43.2598",
    id: "Fill-179",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.627,44.1152 L18.627,43.2602 C18.137,43.0252 17.806,42.8042 17.627,42.6212 L17.627,43.4102 C17.808,43.6232 18.143,43.8652 18.627,44.1152",
    id: "Fill-181",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7979,44.4771 L22.7979,44.3841 C22.4469,44.3221 22.1139,44.2541 21.7979,44.1841 L21.7979,44.2791 C22.1139,44.3491 22.4469,44.4151 22.7979,44.4771",
    id: "Fill-183",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7979,44.2793 L21.7979,45.1833 C22.1139,45.2543 22.4469,45.3213 22.7979,45.3843 L22.7979,44.4773 C22.4469,44.4153 22.1139,44.3493 21.7979,44.2793",
    id: "Fill-185",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9688,44.7676 L25.9688,44.8586 C26.2918,44.8806 26.6268,44.8986 26.9688,44.9126 L26.9688,44.8196 C26.6288,44.8056 26.2908,44.7896 25.9688,44.7676",
    id: "Fill-187",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9688,44.8584 L25.9688,45.7674 C26.2908,45.7904 26.6288,45.8054 26.9688,45.8194 L26.9688,44.9124 C26.6268,44.8984 26.2918,44.8804 25.9688,44.8584",
    id: "Fill-189",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1406,44.8218 L30.1406,44.9158 C30.4826,44.9028 30.8176,44.8858 31.1406,44.8638 L31.1406,44.7708 C30.8186,44.7928 30.4816,44.8078 30.1406,44.8218",
    id: "Fill-191",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1406,45.8218 C30.4816,45.8078 30.8186,45.7928 31.1406,45.7708 L31.1406,44.8638 C30.8176,44.8858 30.4826,44.9028 30.1406,44.9158 L30.1406,45.8218 Z",
    id: "Fill-193",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3115,45.2397 L34.3115,45.3927 C34.6605,45.3307 34.9965,45.2657 35.3115,45.1957 L35.3115,44.9477 C34.9755,45.0517 34.6405,45.1507 34.3115,45.2397",
    id: "Fill-195",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3115,44.4893 C34.6625,44.4273 34.9955,44.3633 35.3115,44.2943 L35.3115,44.1963 C34.9965,44.2663 34.6605,44.3313 34.3115,44.3933 L34.3115,44.4893 Z",
    id: "Fill-197",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3115,45.2397 C34.6405,45.1507 34.9755,45.0517 35.3115,44.9477 L35.3115,44.2937 C34.9955,44.3627 34.6625,44.4277 34.3115,44.4897 L34.3115,45.2397 Z",
    id: "Fill-199",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4824,44.1406 C38.9514,43.9046 39.2864,43.6736 39.4824,43.4666 L39.4824,43.2946 C39.1464,43.4556 38.8134,43.6076 38.4824,43.7526 L38.4824,44.1406 Z",
    id: "Fill-201",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4824,43.1406 L38.4824,43.2896 C38.9444,43.0746 39.2824,42.8676 39.4824,42.6906 L39.4824,42.4666 C39.2864,42.6736 38.9514,42.9046 38.4824,43.1406",
    id: "Fill-203",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4824,43.7529 C38.8134,43.6069 39.1464,43.4559 39.4824,43.2949 L39.4824,42.6909 C39.2824,42.8669 38.9444,43.0749 38.4824,43.2899 L38.4824,43.7529 Z",
    id: "Fill-205",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4824,43.4668 L39.4824,44.8828 C40.4274,44.3798 41.1194,43.7768 41.4574,43.0698 L39.9364,43.0698 C39.8454,43.1148 39.7544,43.1598 39.6654,43.2038 C39.6314,43.2848 39.5714,43.3728 39.4824,43.4668",
    id: "Fill-207",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.665,43.1636 L16.665,43.0696 L15.706,43.0696 C16.037,43.7636 16.709,44.3556 17.627,44.8526 L17.627,43.7306 C17,43.3966 16.665,43.1636 16.665,43.1636",
    id: "Fill-209",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3115,45.1958 L35.3115,46.0808 L34.3115,46.0808 L34.3115,45.3928 C33.7795,45.4868 33.2055,45.5688 32.5955,45.6368 C32.1015,45.7358 31.6165,45.8208 31.1405,45.8868 L31.1405,46.0808 L30.1405,46.0808 L30.1405,46.0068 C28.7725,46.1418 27.4885,46.1548 26.2955,46.0808 L25.9685,46.0808 L25.9685,46.0608 C24.8175,45.9728 23.7595,45.8048 22.7975,45.5918 L22.7975,46.0808 L21.7975,46.0808 L21.7975,45.3498 C20.5145,45.0038 19.4505,44.5918 18.6265,44.2198 L18.6265,45.3248 C21.1935,46.3618 24.9625,46.8558 28.5815,46.8558 C32.1725,46.8558 35.9165,46.3698 38.4825,45.3478 L38.4825,44.1408 C37.7505,44.5098 36.6965,44.8878 35.3115,45.1958",
    id: "Fill-211",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.627,43.7305 L17.627,43.4105 C17.521,43.2845 17.463,43.1685 17.463,43.0695 L16.665,43.0695 L16.665,43.1635 C16.665,43.1635 17,43.3965 17.627,43.7305",
    id: "Fill-213",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7002,43.0693 C39.7002,43.1113 39.6832,43.1573 39.6652,43.2043 C39.7552,43.1603 39.8462,43.1143 39.9362,43.0693 L39.7002,43.0693 Z",
    id: "Fill-215",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7979,45.3843 L22.7979,45.5923 C23.7599,45.8043 24.8179,45.9733 25.9689,46.0613 L25.9689,45.7673 C24.7909,45.6863 23.7349,45.5513 22.7979,45.3843",
    id: "Fill-217",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5811,45.8555 C28.0201,45.8555 27.4881,45.8405 26.9691,45.8195 L26.9691,46.0805 L26.2961,46.0805 C27.4881,46.1555 28.7721,46.1425 30.1411,46.0065 L30.1411,45.8215 C29.6381,45.8415 29.1221,45.8555 28.5811,45.8555",
    id: "Fill-219",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1406,45.8872 C31.6166,45.8202 32.1016,45.7362 32.5956,45.6372 C32.1306,45.6902 31.6506,45.7372 31.1406,45.7712 L31.1406,45.8872 Z",
    id: "Fill-221",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.627,44.1152 L18.627,44.2192 C19.45,44.5922 20.515,45.0032 21.798,45.3492 L21.798,45.1832 C20.407,44.8712 19.351,44.4872 18.627,44.1152",
    id: "Fill-223",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.627,43.7305 L17.627,44.8535 C17.936,45.0205 18.267,45.1795 18.627,45.3245 L18.627,44.2195 C18.239,44.0435 17.903,43.8775 17.627,43.7305",
    id: "Fill-225",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.627,43.4102 L17.627,43.7302 C17.903,43.8772 18.239,44.0442 18.627,44.2202 L18.627,44.1152 C18.143,43.8662 17.808,43.6232 17.627,43.4102",
    id: "Fill-227",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7979,46.0806 L22.7979,46.0806 L22.7979,45.5926 C22.4519,45.5166 22.1169,45.4356 21.7979,45.3496 L21.7979,46.0806 Z",
    id: "Fill-229",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7979,45.1836 L21.7979,45.3496 C22.1169,45.4356 22.4519,45.5166 22.7979,45.5926 L22.7979,45.3846 C22.4469,45.3216 22.1139,45.2546 21.7979,45.1836",
    id: "Fill-231",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9688,46.0806 L26.2958,46.0806 C26.1878,46.0736 26.0758,46.0696 25.9688,46.0606 L25.9688,46.0806 Z",
    id: "Fill-233",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9688,45.8193 C26.6288,45.8053 26.2908,45.7903 25.9688,45.7673 L25.9688,46.0613 C26.0758,46.0693 26.1878,46.0733 26.2958,46.0803 L26.9688,46.0803 L26.9688,45.8193 Z",
    id: "Fill-235",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1406,46.0806 L31.1406,46.0806 L31.1406,45.8876 C30.8026,45.9346 30.4696,45.9736 30.1406,46.0066 L30.1406,46.0806 Z",
    id: "Fill-237",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1406,45.8218 L30.1406,46.0068 C30.4696,45.9738 30.8026,45.9348 31.1406,45.8868 L31.1406,45.7708 C30.8186,45.7928 30.4816,45.8078 30.1406,45.8218",
    id: "Fill-239",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3115,46.0806 L35.3115,46.0806 L35.3115,45.1956 C34.9965,45.2666 34.6605,45.3306 34.3115,45.3936 L34.3115,46.0806 Z",
    id: "Fill-241",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4824,44.1406 L38.4824,45.3486 C38.8424,45.2046 39.1714,45.0476 39.4824,44.8826 L39.4824,43.4666 C39.2864,43.6736 38.9514,43.9046 38.4824,44.1406",
    id: "Fill-243",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1699,29.3423 L49.1699,32.2483 L50.3229,32.2483 L50.3229,27.6753 C50.1799,28.3023 49.7779,28.8583 49.1699,29.3423",
    id: "Fill-245",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1465,33.2485 L50.2615,33.2485 C50.2985,33.1175 50.3235,32.9855 50.3235,32.8525 L50.3235,32.7585 C50.2845,32.9275 50.2215,33.0895 50.1465,33.2485",
    id: "Fill-247",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3545,29.3296 C24.9775,29.0276 24.6795,28.6976 24.4745,28.3406 C24.3945,28.3336 24.3135,28.3296 24.2335,28.3226 L24.2335,32.1716 C24.5995,32.1286 24.9735,32.0916 25.3545,32.0596 L25.3545,29.3296 Z",
    id: "Fill-249",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8311,22.6895 C40.8311,22.8655 40.8021,23.0345 40.7651,23.1995 L40.7651,23.2935 C40.7651,23.4265 40.7401,23.5585 40.7031,23.6895 L40.8311,23.6895 C40.8311,23.8865 40.8041,24.0765 40.7571,24.2605 C45.3001,24.6925 47.8581,25.8995 48.3231,26.5175 L48.3231,27.3665 C48.3631,27.2945 48.3901,27.2265 48.3901,27.1655 L48.8381,27.1655 C49.0471,26.8845 49.1701,26.5925 49.1701,26.2905 L49.1701,27.1655 L50.3231,27.1655 L50.3231,26.3775 C50.3221,24.4125 46.2731,22.7605 40.7651,22.2605 L40.7651,22.6895 L40.8311,22.6895 Z",
    id: "Fill-251",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2334,32.8516 L24.2334,32.8516 C24.2334,32.9856 24.2574,33.1176 24.2944,33.2486 L24.3954,33.2486 C24.3344,33.1186 24.2704,32.9886 24.2334,32.8516",
    id: "Fill-253",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3545,32.2485 L25.3545,32.0595 C24.9735,32.0915 24.5995,32.1285 24.2335,32.1715 L24.2335,32.2485 L25.3545,32.2485 Z",
    id: "Fill-255",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6592,34.4448 C33.7282,34.2698 32.6702,34.1278 31.4872,34.0348 L31.4872,34.5638 C32.4242,34.7308 33.4802,34.8648 34.6592,34.9468 L34.6592,34.4448 Z",
    id: "Fill-257",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3164,30.4209 L27.3164,31.9429 C27.7354,31.9299 28.1594,31.9219 28.5874,31.9219 C29.2354,31.9219 29.8664,31.9419 30.4874,31.9719 L30.4874,31.3309 C29.3154,31.0969 28.2394,30.7939 27.3164,30.4209",
    id: "Fill-259",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3164,29.9492 C26.2884,29.9342 26.2604,29.9192 26.2334,29.9032 L26.2334,31.9952 C26.2604,31.9932 26.2894,31.9922 26.3164,31.9912 L26.3164,29.9492 Z",
    id: "Fill-261",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9648,34.854 C41.6968,34.779 42.3748,34.683 43.0008,34.572 L43.0008,31.521 C41.9838,31.683 40.9138,31.797 39.8298,31.868 L39.8298,34.037 C40.2898,34.294 40.6738,34.566 40.9648,34.854",
    id: "Fill-263",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6592,32.415 L34.6592,31.864 C33.5742,31.792 32.5052,31.677 31.4872,31.513 L31.4872,32.032 C32.6052,32.115 33.6702,32.244 34.6592,32.415",
    id: "Fill-265",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8301,33.5557 L38.8301,31.9177 C38.3091,31.9387 37.7891,31.9517 37.2711,31.9517 C36.7361,31.9517 36.1971,31.9377 35.6591,31.9157 L35.6591,32.6077 C36.8701,32.8647 37.9391,33.1847 38.8301,33.5557",
    id: "Fill-267",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.001,34.375 C45.386,34.067 46.44,33.689 47.172,33.32 L47.172,30.444 C46.247,30.813 45.17,31.11 44.001,31.341 L44.001,34.375 Z",
    id: "Fill-269",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1719,32.646 C48.2369,32.577 48.2879,32.512 48.3229,32.449 L48.3229,29.896 C48.2739,29.924 48.2239,29.952 48.1719,29.979 L48.1719,32.646 Z",
    id: "Fill-271",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4873,33.9722 C29.9723,33.9472 29.4383,33.9302 28.8813,33.9262 C29.3553,34.0802 29.8893,34.2282 30.4873,34.3622 L30.4873,33.9722 Z",
    id: "Fill-273",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0459,35.0308 C36.6309,34.8998 36.1689,34.7718 35.6589,34.6528 L35.6589,34.9988 C36.1069,35.0168 36.5669,35.0288 37.0459,35.0308",
    id: "Fill-275",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8301,34.9502 C40.2221,34.9242 40.6001,34.8912 40.9651,34.8542 C40.6741,34.5662 40.2901,34.2942 39.8301,34.0372 L39.8301,34.9502 Z",
    id: "Fill-277",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6592,32.6079 L35.6592,34.6529 C36.1692,34.7719 36.6312,34.8999 37.0462,35.0309 C37.1222,35.0309 37.1932,35.0349 37.2712,35.0349 C37.8122,35.0349 38.3282,35.0209 38.8302,35.0009 L38.8302,33.5559 C37.9392,33.1849 36.8702,32.8649 35.6592,32.6079",
    id: "Fill-279",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6592,32.415 C33.6702,32.244 32.6052,32.115 31.4872,32.032 L31.4872,34.035 C32.6702,34.127 33.7282,34.269 34.6592,34.445 L34.6592,32.415 Z",
    id: "Fill-281",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3164,31.9907 C26.2894,31.9927 26.2604,31.9927 26.2334,31.9947 L26.2334,32.4697 C26.2564,32.5087 26.2814,32.5477 26.3164,32.5887 L26.3164,31.9907 Z",
    id: "Fill-283",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4873,33.9722 L30.4873,31.9722 C29.8663,31.9422 29.2353,31.9222 28.5883,31.9222 C28.1593,31.9222 27.7353,31.9302 27.3163,31.9432 L27.3163,33.2942 C27.7283,33.5062 28.2513,33.7222 28.8813,33.9262 C29.4383,33.9302 29.9723,33.9472 30.4873,33.9722",
    id: "Fill-285",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3896,32.2485 L49.1696,32.2485 L49.1696,29.3425 C48.9216,29.5395 48.6336,29.7215 48.3236,29.8955 L48.3236,32.4495 C48.3636,32.3775 48.3896,32.3095 48.3896,32.2485",
    id: "Fill-287",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1699,26.2905 C49.1699,26.5925 49.0469,26.8845 48.8379,27.1655 L49.1699,27.1655 L49.1699,26.2905 Z",
    id: "Fill-289",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2334,29.9033 C25.9104,29.7233 25.6094,29.5343 25.3544,29.3293 L25.3544,32.0593 C25.6444,32.0353 25.9354,32.0123 26.2334,31.9953 L26.2334,29.9033 Z",
    id: "Fill-291",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2334,32.4697 L26.2334,31.9947 C25.9354,32.0127 25.6444,32.0357 25.3544,32.0597 L25.3544,32.2487 L26.1524,32.2487 C26.1524,32.3147 26.1854,32.3907 26.2334,32.4697",
    id: "Fill-293",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3164,36.2598 L26.7554,36.2598 C26.6014,36.1868 26.4594,36.1098 26.3164,36.0318 L26.3164,36.2598 Z",
    id: "Fill-295",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3164,30.4209 C26.9564,30.2749 26.6254,30.1169 26.3164,29.9489 L26.3164,31.9909 C26.6464,31.9719 26.9774,31.9539 27.3164,31.9429 L27.3164,30.4209 Z",
    id: "Fill-297",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3164,31.9907 L26.3164,32.5887 C26.4974,32.8017 26.8324,33.0447 27.3164,33.2937 L27.3164,31.9427 C26.9774,31.9537 26.6464,31.9717 26.3164,31.9907",
    id: "Fill-299",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4873,29.481 L31.4873,28.293 C31.1563,28.325 30.8223,28.352 30.4873,28.375 L30.4873,29.28 C30.8033,29.351 31.1363,29.419 31.4873,29.481",
    id: "Fill-301",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4873,31.5127 C31.1473,31.4577 30.8143,31.3967 30.4873,31.3307 L30.4873,31.9717 C30.8243,31.9887 31.1593,32.0067 31.4873,32.0317 L31.4873,31.5127 Z",
    id: "Fill-303",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4873,34.5635 L31.4873,34.0355 C31.1633,34.0095 30.8303,33.9895 30.4873,33.9725 L30.4873,34.3625 C30.8033,34.4335 31.1363,34.5015 31.4873,34.5635",
    id: "Fill-305",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4873,32.0317 C31.1593,32.0067 30.8243,31.9887 30.4873,31.9717 L30.4873,33.9717 C30.8303,33.9897 31.1633,34.0097 31.4873,34.0347 L31.4873,32.0317 Z",
    id: "Fill-307",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6592,29.8643 C34.9812,29.8863 35.3192,29.9023 35.6592,29.9163 L35.6592,27.5943 C35.3352,27.6763 35.0012,27.7533 34.6592,27.8243 L34.6592,29.8643 Z",
    id: "Fill-309",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6592,32.6079 L35.6592,31.9159 C35.3252,31.9019 34.9912,31.8859 34.6592,31.8639 L34.6592,32.4149 C35.0032,32.4739 35.3352,32.5389 35.6592,32.6079",
    id: "Fill-311",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6592,34.9468 C34.9812,34.9688 35.3192,34.9848 35.6592,34.9988 L35.6592,34.6528 C35.3462,34.5798 35.0092,34.5108 34.6592,34.4448 L34.6592,34.9468 Z",
    id: "Fill-313",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6592,34.6528 L35.6592,32.6078 C35.3352,32.5388 35.0032,32.4738 34.6592,32.4148 L34.6592,34.4448 C35.0092,34.5108 35.3462,34.5798 35.6592,34.6528",
    id: "Fill-315",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8301,27.5835 L38.8301,27.5835 L38.8301,29.9185 C39.1711,29.9055 39.5081,29.8895 39.8301,29.8675 L39.8301,27.5835 Z",
    id: "Fill-317",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8301,34.0371 L39.8301,31.8681 C39.4981,31.8891 39.1641,31.9051 38.8301,31.9181 L38.8301,33.5561 C39.1961,33.7081 39.5281,33.8691 39.8301,34.0371",
    id: "Fill-319",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8301,33.5557 L38.8301,35.0007 C39.1711,34.9877 39.5081,34.9727 39.8301,34.9507 L39.8301,34.0367 C39.5281,33.8687 39.1961,33.7077 38.8301,33.5557",
    id: "Fill-321",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.001,27.5835 L43.001,27.5835 L43.001,29.4895 C43.35,29.4285 43.686,29.3625 44.001,29.2925 L44.001,27.5835 Z",
    id: "Fill-323",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.001,34.375 L44.001,31.341 C43.674,31.406 43.341,31.466 43.001,31.521 L43.001,34.572 C43.35,34.511 43.686,34.445 44.001,34.375",
    id: "Fill-325",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1719,36.2598 L48.1719,36.0618 C48.0459,36.1288 47.9209,36.1968 47.7859,36.2598 L48.1719,36.2598 Z",
    id: "Fill-327",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1719,27.5835 L47.1719,28.2375 C47.6259,28.0085 47.9509,27.7855 48.1509,27.5835 L47.1719,27.5835 Z",
    id: "Fill-329",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1719,32.646 L48.1719,29.979 C47.8609,30.144 47.5319,30.301 47.1719,30.444 L47.1719,33.32 C47.6409,33.084 47.9759,32.853 48.1719,32.646",
    id: "Fill-331",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2617,30.0771 C37.7947,30.0771 38.3157,30.0621 38.8297,30.0401 L38.8297,29.9181 C38.3277,29.9381 37.8127,29.9521 37.2717,29.9521 C36.7107,29.9521 36.1777,29.9371 35.6587,29.9161 L35.6587,30.0391 C36.1847,30.0611 36.7167,30.0771 37.2617,30.0771",
    id: "Fill-333",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.001,29.6079 L43.001,29.4899 C42.064,29.6549 41.008,29.7879 39.83,29.8679 L39.83,29.9859 C40.955,29.9079 42.021,29.7799 43.001,29.6079",
    id: "Fill-335",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.543,28.4736 C28.348,28.8346 29.343,29.1496 30.487,29.4026 L30.487,29.2796 C29.423,29.0406 28.559,28.7596 27.884,28.4736 C27.826,28.4736 27.769,28.4756 27.712,28.4756 C27.656,28.4756 27.6,28.4736 27.543,28.4736",
    id: "Fill-337",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4873,29.6011 C32.4673,29.7741 33.5333,29.9041 34.6593,29.9831 L34.6593,29.8641 C33.4803,29.7831 32.4243,29.6481 31.4873,29.4811 L31.4873,29.6011 Z",
    id: "Fill-339",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1719,28.3887 L47.1719,28.2377 C46.4409,28.6067 45.3859,28.9857 44.0009,29.2927 L44.0009,29.4107 C45.2509,29.1377 46.3289,28.7907 47.1719,28.3887",
    id: "Fill-341",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1504,27.5835 L48.1714,27.5835 L48.1714,27.8055 C48.2254,27.7665 48.2734,27.7265 48.3234,27.6875 L48.3234,27.3665 C48.2854,27.4345 48.2254,27.5075 48.1504,27.5835",
    id: "Fill-343",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8379,27.1655 L48.3899,27.1655 C48.3899,27.2265 48.3629,27.2945 48.3229,27.3665 L48.3229,27.6865 C48.5329,27.5195 48.7039,27.3445 48.8379,27.1655",
    id: "Fill-345",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3232,27.6753 L50.3232,27.1653 L49.1702,27.1653 L49.1702,29.3423 C49.7782,28.8583 50.1792,28.3023 50.3232,27.6753",
    id: "Fill-347",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4746,28.3403 C24.6796,28.6973 24.9776,29.0273 25.3546,29.3293 L25.3546,28.4063 C25.0596,28.3883 24.7666,28.3643 24.4746,28.3403",
    id: "Fill-349",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4873,29.4023 C29.3423,29.1503 28.3473,28.8353 27.5433,28.4733 C27.4673,28.4733 27.3913,28.4703 27.3163,28.4703 L27.3163,30.4213 C28.2393,30.7943 29.3153,31.0963 30.4873,31.3313 L30.4873,29.4023 Z",
    id: "Fill-351",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3164,28.4492 C26.2894,28.4482 26.2604,28.4462 26.2334,28.4452 L26.2334,29.9032 C26.2604,29.9192 26.2884,29.9342 26.3164,29.9492 L26.3164,28.4492 Z",
    id: "Fill-353",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3232,29.8955 L48.3232,27.6875 C48.2732,27.7265 48.2252,27.7665 48.1722,27.8055 L48.1722,29.9785 C48.2232,29.9515 48.2732,29.9235 48.3232,29.8955",
    id: "Fill-355",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.001,31.5205 L43.001,29.6075 C42.021,29.7795 40.955,29.9075 39.83,29.9865 L39.83,31.8675 C40.914,31.7975 41.983,31.6825 43.001,31.5205",
    id: "Fill-357",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1719,30.4443 L47.1719,28.3883 C46.3289,28.7903 45.2509,29.1373 44.0009,29.4113 L44.0009,31.3413 C45.1699,31.1103 46.2469,30.8133 47.1719,30.4443",
    id: "Fill-359",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4873,31.5127 C32.5053,31.6767 33.5743,31.7917 34.6593,31.8637 L34.6593,29.9837 C33.5333,29.9037 32.4673,29.7747 31.4873,29.6007 L31.4873,31.5127 Z",
    id: "Fill-361",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2715,31.9521 C37.7895,31.9521 38.3095,31.9381 38.8305,31.9181 L38.8305,30.0401 C38.3155,30.0621 37.7945,30.0771 37.2615,30.0771 C36.7165,30.0771 36.1845,30.0611 35.6595,30.0391 L35.6595,31.9151 C36.1975,31.9371 36.7365,31.9521 37.2715,31.9521",
    id: "Fill-363",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2334,28.4453 C25.9404,28.4343 25.6464,28.4233 25.3544,28.4063 L25.3544,29.3293 C25.6094,29.5343 25.9104,29.7233 26.2334,29.9033 L26.2334,28.4453 Z",
    id: "Fill-365",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3232,27.687 L48.3232,29.895 C48.6342,29.722 48.9222,29.54 49.1702,29.342 L49.1702,27.166 L48.8382,27.166 C48.7042,27.345 48.5332,27.519 48.3232,27.687",
    id: "Fill-367",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3164,28.4702 C26.9834,28.4672 26.6504,28.4612 26.3164,28.4492 L26.3164,29.9492 C26.6254,30.1162 26.9564,30.2752 27.3164,30.4212 L27.3164,28.4702 Z",
    id: "Fill-369",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4873,29.481 C31.1363,29.419 30.8033,29.351 30.4873,29.28 L30.4873,29.402 C30.8093,29.474 31.1423,29.54 31.4873,29.601 L31.4873,29.481 Z",
    id: "Fill-371",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4873,31.5127 L31.4873,29.6007 C31.1423,29.5397 30.8093,29.4737 30.4873,29.4027 L30.4873,31.3307 C30.8143,31.3967 31.1473,31.4577 31.4873,31.5127",
    id: "Fill-373",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6592,29.9834 C34.9872,30.0064 35.3212,30.0244 35.6592,30.0394 L35.6592,29.9164 C35.3192,29.9014 34.9812,29.8864 34.6592,29.8644 L34.6592,29.9834 Z",
    id: "Fill-375",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6592,31.9155 L35.6592,30.0395 C35.3212,30.0245 34.9872,30.0065 34.6592,29.9835 L34.6592,31.8635 C34.9912,31.8855 35.3252,31.9025 35.6592,31.9155",
    id: "Fill-377",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8301,29.9863 L39.8301,29.8673 C39.5081,29.8893 39.1711,29.9053 38.8301,29.9183 L38.8301,30.0403 C39.1681,30.0263 39.5021,30.0093 39.8301,29.9863",
    id: "Fill-379",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8301,31.8677 L39.8301,29.9867 C39.5021,30.0097 39.1681,30.0267 38.8301,30.0407 L38.8301,31.9177 C39.1641,31.9047 39.4981,31.8887 39.8301,31.8677",
    id: "Fill-381",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.001,29.4111 L44.001,29.2921 C43.686,29.3631 43.35,29.4281 43.001,29.4901 L43.001,29.6081 C43.346,29.5471 43.679,29.4811 44.001,29.4111",
    id: "Fill-383",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.001,31.3413 L44.001,29.4113 C43.679,29.4813 43.346,29.5473 43.001,29.6083 L43.001,31.5203 C43.341,31.4663 43.674,31.4053 44.001,31.3413",
    id: "Fill-385",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1719,27.8057 L48.1719,27.5837 L48.1509,27.5837 C47.9509,27.7847 47.6259,28.0087 47.1719,28.2377 L47.1719,28.3887 C47.5579,28.2047 47.8909,28.0097 48.1719,27.8057",
    id: "Fill-387",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1719,30.4443 C47.5319,30.3003 47.8609,30.1433 48.1719,29.9783 L48.1719,27.8053 C47.8909,28.0093 47.5579,28.2053 47.1719,28.3883 L47.1719,30.4443 Z",
    id: "Fill-389",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1406,37.5342 C32.1536,37.7102 33.2216,37.8382 34.3116,37.9202 L34.3116,37.4042 L35.3116,37.4042 L35.3116,37.9822 C35.9646,38.0142 36.6196,38.0342 37.2716,38.0342 C37.6736,38.0342 38.0776,38.0282 38.4826,38.0162 L38.4826,37.4042 L39.4606,37.4042 C39.5356,37.3282 39.5946,37.2562 39.6326,37.1872 L39.6326,37.0552 C38.8686,37.1012 38.0836,37.1292 37.2786,37.1292 C33.2816,37.1292 29.7086,36.5382 27.3166,35.6102 L27.3166,36.2602 L26.7556,36.2602 C27.7776,36.7412 29.0376,37.1222 30.4356,37.4042 L31.1406,37.4042 L31.1406,37.5342 Z",
    id: "Fill-391",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2617,33.2485 C50.0607,33.9655 49.3197,34.6315 48.1717,35.2015 L48.1717,36.0615 C49.3287,35.4455 50.1127,34.6825 50.3237,33.7585 L50.3237,33.2485 L50.2617,33.2485 Z",
    id: "Fill-393",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3164,36.0322 L26.3164,35.1652 C25.6794,34.8412 25.1664,34.4902 24.8124,34.1142 C24.6604,34.1302 24.5084,34.1462 24.3614,34.1642 C24.6764,34.8942 25.3624,35.5152 26.3164,36.0322",
    id: "Fill-395",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1719,35.6348 C45.7029,36.1958 43.8009,36.6278 41.6329,36.8798 L41.6329,36.9868 L41.6999,36.9868 C41.6999,37.1628 41.6709,37.3318 41.6329,37.4978 L41.6329,37.7878 C44.0009,37.5148 46.1889,37.0128 47.7859,36.2598 L47.1719,36.2598 L47.1719,35.6348 Z",
    id: "Fill-397",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2939,33.2485 L24.1519,33.2485 C24.1519,33.5725 24.2359,33.8745 24.3609,34.1645 C24.5089,34.1465 24.6599,34.1295 24.8129,34.1145 C24.5509,33.8365 24.3779,33.5465 24.2939,33.2485",
    id: "Fill-399",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6328,37.0557 L39.6328,37.1877 C39.6598,37.1397 39.6738,37.0967 39.6828,37.0537 C39.6658,37.0547 39.6498,37.0547 39.6328,37.0557",
    id: "Fill-401",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5342,37.7983 C41.5662,37.7953 41.6002,37.7913 41.6332,37.7873 L41.6332,37.4983 C41.6092,37.6013 41.5712,37.6993 41.5342,37.7983",
    id: "Fill-403",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6328,36.9863 L41.6328,36.8793 C41.2838,36.9203 40.9298,36.9553 40.5678,36.9863 L41.6328,36.9863 Z",
    id: "Fill-405",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1406,37.4043 L30.4356,37.4043 C30.6656,37.4503 30.9036,37.4923 31.1406,37.5343 L31.1406,37.4043 Z",
    id: "Fill-407",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3115,37.4043 L34.3115,37.4043 L34.3115,37.9203 C34.6435,37.9453 34.9765,37.9663 35.3115,37.9823 L35.3115,37.4043 Z",
    id: "Fill-409",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4609,37.4043 L38.4819,37.4043 L38.4819,38.0163 C38.5149,38.0153 38.5469,38.0123 38.5779,38.0113 C38.9849,37.7993 39.2749,37.5923 39.4609,37.4043",
    id: "Fill-411",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7002,36.9863 L41.6332,36.9863 L41.6332,37.4983 C41.6712,37.3323 41.7002,37.1633 41.7002,36.9863",
    id: "Fill-413",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4609,37.4043 L39.4819,37.4043 L39.4819,37.6263 C39.5359,37.5873 39.5839,37.5473 39.6329,37.5083 L39.6329,37.1873 C39.5949,37.2563 39.5349,37.3283 39.4609,37.4043",
    id: "Fill-415",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4805,36.9937 L40.4805,37.9017 C40.8345,37.8717 41.1855,37.8377 41.5345,37.7987 C41.5715,37.6997 41.6095,37.6007 41.6325,37.4977 L41.6325,36.9867 L40.5675,36.9867 C40.5385,36.9887 40.5085,36.9917 40.4805,36.9937",
    id: "Fill-417",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6328,37.1875 L39.6328,37.5075 C39.8278,37.3515 39.9868,37.1895 40.1168,37.0245 C39.9728,37.0345 39.8278,37.0445 39.6828,37.0535 C39.6738,37.0965 39.6598,37.1405 39.6328,37.1875",
    id: "Fill-419",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4824,37.626 L39.4824,37.971 C39.5324,37.969 39.5834,37.968 39.6324,37.965 L39.6324,37.508 C39.5844,37.547 39.5364,37.587 39.4824,37.626",
    id: "Fill-421",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6328,37.5078 L39.6328,37.9648 C39.9168,37.9478 40.1978,37.9248 40.4808,37.9018 L40.4808,36.9938 C40.3588,37.0038 40.2388,37.0158 40.1168,37.0248 C39.9868,37.1898 39.8278,37.3518 39.6328,37.5078",
    id: "Fill-423",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4609,37.4043 C39.2749,37.5923 38.9849,37.7993 38.5779,38.0113 C38.6819,38.0083 38.7839,38.0023 38.8869,37.9983 C39.1049,37.8783 39.3069,37.7543 39.4819,37.6263 L39.4819,37.4043 L39.4609,37.4043 Z",
    id: "Fill-425",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4824,37.9712 L39.4824,37.6262 C39.3064,37.7542 39.1044,37.8782 38.8864,37.9982 C39.0854,37.9902 39.2844,37.9822 39.4824,37.9712",
    id: "Fill-427",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0098,34.0923 C24.9428,34.0983 24.8788,34.1073 24.8128,34.1143 C25.1658,34.4893 25.6798,34.8413 26.3168,35.1653 L26.3168,35.0323 C25.7958,34.7503 25.3558,34.4373 25.0098,34.0923",
    id: "Fill-429",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3164,35.5039 L27.3164,35.6099 C29.7094,36.5379 33.2814,37.1289 37.2784,37.1289 C38.0844,37.1289 38.8684,37.1019 39.6324,37.0559 L39.6324,36.9649 C38.8474,37.0109 38.0554,37.0349 37.2714,37.0349 C33.6534,37.0349 29.8824,36.5409 27.3164,35.5039",
    id: "Fill-431",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1719,35.0615 L48.1719,35.2015 C49.3189,34.6315 50.0609,33.9655 50.2619,33.2485 L50.1469,33.2485 C49.8089,33.9565 49.1169,34.5585 48.1719,35.0615",
    id: "Fill-433",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6328,36.7876 L41.6328,36.8796 C43.8008,36.6276 45.7028,36.1956 47.1718,35.6346 L47.1718,35.5276 C45.6488,36.1336 43.7098,36.5486 41.6328,36.7876",
    id: "Fill-435",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4805,36.9014 L40.4805,36.9864 L40.5675,36.9864 C40.9295,36.9554 41.2845,36.9204 41.6325,36.8794 L41.6325,36.7874 C41.2515,36.8314 40.8685,36.8694 40.4805,36.9014",
    id: "Fill-437",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0098,34.0923 C24.7458,33.8293 24.5388,33.5493 24.3958,33.2483 L24.2938,33.2483 C24.3778,33.5473 24.5508,33.8373 24.8128,34.1143 C24.8788,34.1073 24.9428,34.0983 25.0098,34.0923",
    id: "Fill-439",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6826,37.0532 C39.6876,37.0312 39.7006,37.0072 39.7006,36.9862 L40.1476,36.9862 C40.1636,36.9652 40.1846,36.9442 40.1996,36.9222 C40.0106,36.9362 39.8236,36.9532 39.6326,36.9652 L39.6326,37.0552 C39.6496,37.0542 39.6656,37.0542 39.6826,37.0532",
    id: "Fill-441",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1475,36.9863 L40.4805,36.9863 L40.4805,36.9013 C40.3865,36.9083 40.2935,36.9153 40.1995,36.9223 C40.1845,36.9443 40.1645,36.9653 40.1475,36.9863",
    id: "Fill-443",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6826,37.0532 C39.8286,37.0442 39.9726,37.0342 40.1176,37.0242 C40.1266,37.0112 40.1386,36.9992 40.1476,36.9862 L39.7006,36.9862 C39.7006,37.0072 39.6876,37.0312 39.6826,37.0532",
    id: "Fill-445",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5674,36.9863 L40.4804,36.9863 L40.4804,36.9933 C40.5084,36.9913 40.5384,36.9883 40.5674,36.9863",
    id: "Fill-447",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1172,37.0244 C40.2392,37.0154 40.3582,37.0034 40.4802,36.9934 L40.4802,36.9864 L40.1472,36.9864 C40.1382,36.9994 40.1272,37.0114 40.1172,37.0244",
    id: "Fill-449",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3164,35.6099 C26.9544,35.4689 26.6224,35.3199 26.3164,35.1649 L26.3164,36.0319 C26.4594,36.1099 26.6014,36.1869 26.7554,36.2599 L27.3164,36.2599 L27.3164,35.6099 Z",
    id: "Fill-451",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3164,35.5039 C26.9564,35.3579 26.6254,35.1989 26.3164,35.0319 L26.3164,35.1649 C26.6224,35.3199 26.9544,35.4689 27.3164,35.6099 L27.3164,35.5039 Z",
    id: "Fill-453",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1719,35.6348 L47.1719,36.2598 L47.7859,36.2598 C47.9209,36.1968 48.0459,36.1288 48.1719,36.0618 L48.1719,35.2018 C47.8669,35.3538 47.5309,35.4968 47.1719,35.6348",
    id: "Fill-455",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1719,35.5273 L47.1719,35.6343 C47.5309,35.4973 47.8669,35.3533 48.1719,35.2013 L48.1719,35.0613 C47.8609,35.2263 47.5319,35.3833 47.1719,35.5273",
    id: "Fill-457",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1523,32.2485 C24.1523,32.4565 24.1803,32.6575 24.2333,32.8515 L24.2333,32.2485 L24.1523,32.2485 Z",
    id: "Fill-459",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1719,33.646 C48.2609,33.552 48.3209,33.465 48.3549,33.383 C48.2939,33.413 48.2329,33.445 48.1719,33.474 L48.1719,33.646 Z",
    id: "Fill-461",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1699,32.979 C48.9869,33.075 48.8079,33.158 48.6259,33.249 L50.1469,33.249 C50.2219,33.09 50.2839,32.928 50.3229,32.758 L50.3229,32.249 L49.1699,32.249 L49.1699,32.979 Z",
    id: "Fill-463",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5654,35.7612 C41.5674,35.7682 41.5664,35.7752 41.5694,35.7822 C42.0714,35.7202 42.5534,35.6512 43.0014,35.5722 L43.0014,35.4192 C42.5144,35.5502 42.0374,35.6612 41.5654,35.7612",
    id: "Fill-465",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.001,35.127 L44.001,35.375 C45.386,35.067 46.44,34.689 47.172,34.32 L47.172,33.933 C46.087,34.41 45.027,34.808 44.001,35.127",
    id: "Fill-467",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2842,35.8169 C41.3812,35.8059 41.4742,35.7939 41.5692,35.7819 C41.5662,35.7749 41.5672,35.7679 41.5652,35.7609 C41.4712,35.7809 41.3782,35.7979 41.2842,35.8169",
    id: "Fill-469",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3545,33.2485 L25.3545,32.2485 L24.2335,32.2485 L24.2335,32.8515 C24.2705,32.9885 24.3335,33.1185 24.3955,33.2485 L25.3545,33.2485 Z",
    id: "Fill-471",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6592,35.0918 C36.1802,35.1128 36.7152,35.1288 37.2782,35.1288 C37.2972,35.1288 37.3142,35.1278 37.3342,35.1278 C37.2382,35.0958 37.1462,35.0628 37.0462,35.0308 C36.5672,35.0288 36.1062,35.0168 35.6592,34.9988 L35.6592,35.0918 Z",
    id: "Fill-473",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3232,32.7124 L48.3232,32.4494 C48.2882,32.5114 48.2372,32.5774 48.1722,32.6464 L48.1722,32.8704 C48.2352,32.8144 48.2862,32.7614 48.3232,32.7124",
    id: "Fill-475",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6592,34.9468 C33.4802,34.8648 32.4242,34.7308 31.4872,34.5638 L31.4872,34.6558 C32.4252,34.8218 33.4802,34.9558 34.6592,35.0378 L34.6592,34.9468 Z",
    id: "Fill-477",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.001,34.5723 C42.375,34.6833 41.697,34.7793 40.965,34.8543 C40.993,34.8823 41.027,34.9083 41.054,34.9363 C41.752,34.8633 42.401,34.7733 43.001,34.6683 L43.001,34.5723 Z",
    id: "Fill-479",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8809,33.9263 C28.7819,33.9263 28.6889,33.9223 28.5879,33.9223 C28.5689,33.9223 28.5519,33.9233 28.5329,33.9233 C29.0879,34.1113 29.7399,34.2933 30.4869,34.4583 L30.4869,34.3623 C29.8899,34.2283 29.3559,34.0803 28.8809,33.9263",
    id: "Fill-481",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1719,33.4697 L47.1719,33.3207 C46.4409,33.6887 45.3859,34.0677 44.0009,34.3747 L44.0009,34.4727 C45.3799,34.1737 46.4399,33.8117 47.1719,33.4697",
    id: "Fill-483",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5879,33.9219 C28.6889,33.9219 28.7819,33.9259 28.8809,33.9259 C28.2509,33.7219 27.7289,33.5059 27.3169,33.2939 L27.3169,33.4389 C27.6499,33.5979 28.0579,33.7619 28.5329,33.9229 C28.5519,33.9229 28.5689,33.9219 28.5879,33.9219",
    id: "Fill-485",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2334,32.4697 L26.2334,32.7127 C26.2544,32.7397 26.2874,32.7707 26.3164,32.8007 L26.3164,32.5887 C26.2814,32.5477 26.2564,32.5087 26.2334,32.4697",
    id: "Fill-487",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0459,35.0308 C37.1469,35.0628 37.2379,35.0958 37.3339,35.1278 C37.8529,35.1278 38.3479,35.1138 38.8299,35.0948 L38.8299,35.0008 C38.3279,35.0208 37.8129,35.0348 37.2719,35.0348 C37.1929,35.0348 37.1219,35.0308 37.0459,35.0308",
    id: "Fill-489",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9648,34.854 C40.5998,34.891 40.2218,34.924 39.8298,34.95 L39.8298,35.043 C40.2548,35.014 40.6598,34.978 41.0538,34.937 C41.0268,34.909 40.9928,34.882 40.9648,34.854",
    id: "Fill-491",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2783,35.1289 C36.7153,35.1289 36.1803,35.1129 35.6593,35.0919 L35.6593,35.9989 C36.1773,36.0199 36.7113,36.0349 37.2713,36.0349 C37.8123,36.0349 38.3283,36.0209 38.8303,36.0009 L38.8303,35.7549 C38.4533,35.5529 37.9533,35.3379 37.3343,35.1279 C37.3143,35.1279 37.2973,35.1289 37.2783,35.1289",
    id: "Fill-493",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3232,32.4492 L48.3232,32.7122 C48.2862,32.7612 48.2352,32.8142 48.1722,32.8702 L48.1722,33.4732 C48.2322,33.4452 48.2942,33.4132 48.3542,33.3832 C48.3732,33.3362 48.3892,33.2902 48.3892,33.2482 L48.6262,33.2482 C48.8072,33.1572 48.9872,33.0742 49.1702,32.9792 L49.1702,32.2482 L48.3892,32.2482 C48.3892,32.3092 48.3632,32.3772 48.3232,32.4492",
    id: "Fill-495",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0537,34.9365 C41.3037,35.2015 41.4777,35.4775 41.5657,35.7615 C42.0367,35.6615 42.5147,35.5505 43.0007,35.4185 L43.0007,34.6685 C42.4017,34.7725 41.7517,34.8635 41.0537,34.9365",
    id: "Fill-497",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.001,34.4731 L44.001,35.1271 C45.027,34.8081 46.087,34.4101 47.172,33.9321 L47.172,33.4701 C46.439,33.8111 45.38,34.1731 44.001,34.4731",
    id: "Fill-499",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4873,35.3623 L30.4873,34.4583 C29.7403,34.2933 29.0883,34.1113 28.5333,33.9233 C28.1163,33.9233 27.7103,33.9303 27.3163,33.9433 L27.3163,34.2943 C28.0403,34.6663 29.0963,35.0503 30.4873,35.3623",
    id: "Fill-501",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4873,34.6562 L31.4873,35.5632 C32.4243,35.7312 33.4803,35.8652 34.6593,35.9472 L34.6593,35.0372 C33.4803,34.9552 32.4243,34.8222 31.4873,34.6562",
    id: "Fill-503",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3164,33.439 L27.3164,33.943 C27.7104,33.93 28.1164,33.923 28.5334,33.923 C28.0574,33.762 27.6494,33.598 27.3164,33.439",
    id: "Fill-505",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0537,34.9365 C40.6597,34.9785 40.2547,35.0145 39.8297,35.0425 L39.8297,35.9505 C40.3397,35.9155 40.8197,35.8695 41.2837,35.8165 C41.3777,35.7975 41.4707,35.7815 41.5657,35.7615 C41.4777,35.4775 41.3037,35.2015 41.0537,34.9365",
    id: "Fill-507",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1523,33.2485 C26.1523,33.3475 26.2103,33.4635 26.3163,33.5885 L26.3163,32.8005 C26.2873,32.7705 26.2543,32.7395 26.2333,32.7125 L26.2333,32.4695 C26.1853,32.3905 26.1523,32.3145 26.1523,32.2485 L25.3543,32.2485 L25.3543,33.2485 L26.1523,33.2485 Z",
    id: "Fill-509",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8301,35.7549 L38.8301,35.0949 C38.3481,35.1139 37.8521,35.1279 37.3341,35.1279 C37.9531,35.3379 38.4531,35.5529 38.8301,35.7549",
    id: "Fill-511",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3164,33.439 L27.3164,33.294 C26.8324,33.045 26.4974,32.802 26.3164,32.589 L26.3164,32.8 C26.4954,32.983 26.8264,33.204 27.3164,33.439",
    id: "Fill-513",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3164,33.9429 C27.1274,33.9489 26.9484,33.9599 26.7644,33.9689 C26.9204,34.0749 27.1014,34.1839 27.3164,34.2939 L27.3164,33.9429 Z",
    id: "Fill-515",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7646,33.9687 C26.9486,33.9597 27.1266,33.9487 27.3166,33.9427 L27.3166,33.4387 C26.8266,33.2037 26.4946,32.9837 26.3166,32.8007 L26.3166,33.5887 C26.4166,33.7077 26.5706,33.8357 26.7646,33.9687",
    id: "Fill-517",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4873,34.5635 C31.1363,34.5015 30.8033,34.4335 30.4873,34.3625 L30.4873,34.4585 C30.8033,34.5285 31.1363,34.5945 31.4873,34.6565 L31.4873,34.5635 Z",
    id: "Fill-519",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4873,34.6562 C31.1363,34.5942 30.8033,34.5282 30.4873,34.4582 L30.4873,35.3622 C30.8033,35.4332 31.1363,35.5012 31.4873,35.5632 L31.4873,34.6562 Z",
    id: "Fill-521",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6592,34.9468 L34.6592,35.0378 C34.9822,35.0598 35.3172,35.0778 35.6592,35.0918 L35.6592,34.9988 C35.3192,34.9848 34.9812,34.9688 34.6592,34.9468",
    id: "Fill-523",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6592,35.0376 L34.6592,35.9466 C34.9812,35.9686 35.3192,35.9846 35.6592,35.9986 L35.6592,35.0916 C35.3172,35.0776 34.9822,35.0596 34.6592,35.0376",
    id: "Fill-525",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8301,35.001 L38.8301,35.095 C39.1721,35.081 39.5071,35.065 39.8301,35.043 L39.8301,34.95 C39.5081,34.972 39.1711,34.987 38.8301,35.001",
    id: "Fill-527",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8301,36.001 C38.9611,35.996 39.0871,35.988 39.2151,35.981 C39.1051,35.909 38.9761,35.833 38.8301,35.755 L38.8301,36.001 Z",
    id: "Fill-529",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8301,35.7549 C38.9761,35.8329 39.1051,35.9089 39.2151,35.9819 C39.4201,35.9709 39.6321,35.9639 39.8301,35.9499 L39.8301,35.0429 C39.5071,35.0649 39.1721,35.0809 38.8301,35.0949 L38.8301,35.7549 Z",
    id: "Fill-531",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.001,35.4189 L43.001,35.5719 C43.35,35.5109 43.686,35.4449 44.001,35.3749 L44.001,35.1269 C43.665,35.2319 43.33,35.3299 43.001,35.4189",
    id: "Fill-533",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.001,34.6685 C43.352,34.6075 43.685,34.5425 44.001,34.4735 L44.001,34.3755 C43.686,34.4455 43.35,34.5105 43.001,34.5725 L43.001,34.6685 Z",
    id: "Fill-535",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.001,34.6685 L43.001,35.4185 C43.33,35.3305 43.665,35.2315 44.001,35.1265 L44.001,34.4735 C43.685,34.5425 43.352,34.6075 43.001,34.6685",
    id: "Fill-537",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1719,33.9326 L47.1719,34.3206 C47.6409,34.0836 47.9759,33.8526 48.1719,33.6456 L48.1719,33.4736 C47.8359,33.6356 47.5029,33.7866 47.1719,33.9326",
    id: "Fill-539",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1719,33.4697 C47.6339,33.2537 47.9719,33.0467 48.1719,32.8697 L48.1719,32.6457 C47.9759,32.8527 47.6409,33.0837 47.1719,33.3207 L47.1719,33.4697 Z",
    id: "Fill-541",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1719,33.9326 C47.5029,33.7866 47.8359,33.6356 48.1719,33.4736 L48.1719,32.8706 C47.9719,33.0466 47.6339,33.2536 47.1719,33.4696 L47.1719,33.9326 Z",
    id: "Fill-543",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8301,36.1855 C37.4631,36.3215 36.1781,36.3345 34.9851,36.2595 L34.6591,36.2595 L34.6591,36.2405 C33.5081,36.1525 32.4491,35.9835 31.4871,35.7715 L31.4871,36.2595 L30.4871,36.2595 L30.4871,35.5285 C29.2041,35.1825 28.1401,34.7715 27.3161,34.3985 L27.3161,35.5035 C29.8831,36.5405 33.6531,37.0345 37.2711,37.0345 C38.0561,37.0345 38.8481,37.0115 39.6331,36.9645 L39.6331,36.3385 C39.6151,36.3135 39.5841,36.2865 39.5591,36.2595 L38.8301,36.2595 L38.8301,36.1855 Z",
    id: "Fill-545",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3164,33.9893 C25.8634,34.0163 25.4284,34.0513 25.0094,34.0923 C25.3554,34.4373 25.7954,34.7503 26.3164,35.0323 L26.3164,33.9893 Z",
    id: "Fill-547",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.001,35.375 L44.001,36.26 L43.001,36.26 L43.001,35.572 C42.554,35.651 42.071,35.72 41.569,35.782 C41.609,35.919 41.633,36.059 41.633,36.199 L41.633,36.788 C43.71,36.549 45.648,36.134 47.172,35.527 L47.172,34.32 C46.44,34.689 45.386,35.067 44.001,35.375",
    id: "Fill-549",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3545,33.3833 C48.3215,33.4653 48.2605,33.5523 48.1715,33.6463 L48.1715,35.0613 C49.1175,34.5583 49.8085,33.9563 50.1465,33.2483 L48.6255,33.2483 C48.5355,33.2943 48.4445,33.3393 48.3545,33.3833",
    id: "Fill-551",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5693,35.7817 C41.4743,35.7937 41.3813,35.8057 41.2843,35.8167 C40.7913,35.9147 40.3053,35.9997 39.8303,36.0667 L39.8303,36.2597 L39.5583,36.2597 C39.5843,36.2857 39.6153,36.3137 39.6323,36.3387 L39.6323,36.9647 C39.8233,36.9527 40.0103,36.9367 40.1993,36.9227 C40.3793,36.6607 40.4803,36.3897 40.4803,36.1117 L40.4803,36.9017 C40.8683,36.8687 41.2523,36.8317 41.6323,36.7877 L41.6323,36.1987 C41.6323,36.0587 41.6093,35.9197 41.5693,35.7817",
    id: "Fill-553",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3164,33.9092 C25.6894,33.5762 25.3544,33.3432 25.3544,33.3432 L25.3544,33.2482 L24.3954,33.2482 C24.5394,33.5492 24.7464,33.8292 25.0094,34.0922 C25.4284,34.0512 25.8634,34.0162 26.3164,33.9892 L26.3164,33.9092 Z",
    id: "Fill-555",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1992,36.9224 C40.2932,36.9154 40.3862,36.9084 40.4802,36.9014 L40.4802,36.1114 C40.4802,36.3904 40.3792,36.6604 40.1992,36.9224",
    id: "Fill-557",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2715,36.0347 C36.7105,36.0347 36.1775,36.0197 35.6595,35.9987 L35.6595,36.2597 L34.9855,36.2597 C36.1775,36.3347 37.4625,36.3217 38.8305,36.1857 L38.8305,36.0007 C38.3285,36.0207 37.8125,36.0347 37.2715,36.0347",
    id: "Fill-559",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3164,34.2939 L27.3164,34.3979 C28.1394,34.7719 29.2044,35.1829 30.4874,35.5279 L30.4874,35.3619 C29.0964,35.0499 28.0404,34.6659 27.3164,34.2939",
    id: "Fill-561",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3545,33.3833 C48.4445,33.3393 48.5355,33.2943 48.6255,33.2483 L48.3895,33.2483 C48.3895,33.2903 48.3735,33.3363 48.3545,33.3833",
    id: "Fill-563",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4873,35.5635 L31.4873,35.7715 C32.4493,35.9835 33.5083,36.1525 34.6593,36.2405 L34.6593,35.9465 C33.4803,35.8655 32.4243,35.7305 31.4873,35.5635",
    id: "Fill-565",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3164,33.9092 L26.3164,33.5892 C26.2104,33.4632 26.1524,33.3472 26.1524,33.2482 L25.3544,33.2482 L25.3544,33.3432 C25.3544,33.3432 25.6894,33.5762 26.3164,33.9092",
    id: "Fill-567",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8301,36.0664 C40.3061,35.9994 40.7911,35.9154 41.2841,35.8164 C40.8191,35.8694 40.3401,35.9164 39.8301,35.9504 L39.8301,36.0664 Z",
    id: "Fill-569",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.457,33.9829 C26.411,33.9849 26.362,33.9869 26.316,33.9889 L26.316,35.0319 C26.625,35.1989 26.956,35.3579 27.316,35.5039 L27.316,34.3989 C26.991,34.2519 26.704,34.1109 26.457,33.9829",
    id: "Fill-571",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3164,33.9092 L26.3164,33.9892 C26.3624,33.9872 26.4114,33.9852 26.4574,33.9832 C26.4094,33.9582 26.3614,33.9332 26.3164,33.9092",
    id: "Fill-573",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3164,34.2939 C27.1014,34.1839 26.9204,34.0749 26.7644,33.9689 C26.6624,33.9739 26.5574,33.9769 26.4574,33.9829 C26.7044,34.1109 26.9914,34.2519 27.3164,34.3979 L27.3164,34.2939 Z",
    id: "Fill-575",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.457,33.9829 C26.558,33.9769 26.662,33.9739 26.765,33.9689 C26.57,33.8359 26.417,33.7079 26.316,33.5889 L26.316,33.9089 C26.361,33.9329 26.409,33.9579 26.457,33.9829",
    id: "Fill-577",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4873,36.2598 L31.4873,36.2598 L31.4873,35.7718 C31.1413,35.6958 30.8063,35.6148 30.4873,35.5288 L30.4873,36.2598 Z",
    id: "Fill-579",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4873,35.3623 L30.4873,35.5283 C30.8063,35.6143 31.1413,35.6953 31.4873,35.7713 L31.4873,35.5633 C31.1363,35.5013 30.8033,35.4333 30.4873,35.3623",
    id: "Fill-581",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6592,36.2598 L34.9852,36.2598 C34.8772,36.2528 34.7662,36.2488 34.6592,36.2398 L34.6592,36.2598 Z",
    id: "Fill-583",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6592,35.9985 C35.3192,35.9845 34.9812,35.9685 34.6592,35.9465 L34.6592,36.2405 C34.7662,36.2485 34.8772,36.2525 34.9852,36.2595 L35.6592,36.2595 L35.6592,35.9985 Z",
    id: "Fill-585",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4082,36.123 C39.2142,36.147 39.0212,36.167 38.8302,36.185 L38.8302,36.26 L39.5582,36.26 C39.5172,36.216 39.4682,36.171 39.4082,36.123",
    id: "Fill-587",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5586,36.2598 L39.8296,36.2598 L39.8296,36.0668 C39.6886,36.0858 39.5476,36.1058 39.4086,36.1228 C39.4676,36.1708 39.5176,36.2168 39.5586,36.2598",
    id: "Fill-589",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8301,36.1855 C39.0211,36.1665 39.2141,36.1465 39.4081,36.1235 C39.3511,36.0775 39.2891,36.0305 39.2151,35.9815 C39.0871,35.9885 38.9611,35.9965 38.8301,36.0005 L38.8301,36.1855 Z",
    id: "Fill-591",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2148,35.9814 C39.2888,36.0304 39.3518,36.0774 39.4078,36.1234 C39.5478,36.1064 39.6888,36.0854 39.8298,36.0664 L39.8298,35.9504 C39.6318,35.9634 39.4198,35.9714 39.2148,35.9814",
    id: "Fill-593",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.001,36.2598 L44.001,36.2598 L44.001,35.3748 C43.686,35.4458 43.35,35.5108 43.001,35.5728 L43.001,36.2598 Z",
    id: "Fill-595",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1719,34.3203 L47.1719,35.5273 C47.5319,35.3833 47.8609,35.2263 48.1719,35.0613 L48.1719,33.6463 C47.9759,33.8523 47.6409,34.0843 47.1719,34.3203",
    id: "Fill-597",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6113,19.7837 L39.6113,22.1737 C40.0023,22.1967 40.3853,22.2257 40.7643,22.2607 L40.7643,18.1167 C40.6213,18.7447 40.2193,19.2997 39.6113,19.7837",
    id: "Fill-599",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7959,17.6069 L15.7959,16.7319 C15.7959,17.0339 15.9189,17.3259 16.1279,17.6069 L16.5939,17.6069 C16.5939,17.6729 16.6269,17.7489 16.6749,17.8279 L16.6749,16.9589 C17.2469,16.1979 20.9969,14.5429 27.7199,14.5429 C34.4419,14.5429 38.1919,16.1979 38.7649,16.9589 L38.7649,17.8079 C38.8049,17.7359 38.8309,17.6679 38.8309,17.6069 L39.2779,17.6069 C39.4879,17.3259 39.6109,17.0339 39.6109,16.7319 L39.6109,17.6069 L40.7649,17.6069 L40.7649,16.8199 C40.7649,14.4579 34.9239,12.5429 27.7199,12.5429 C20.5149,12.5429 14.6749,14.4579 14.6749,16.8199 L14.6749,17.6069 L15.7959,17.6069 Z",
    id: "Fill-601",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7959,19.771 C15.2259,19.313 14.8329,18.794 14.6749,18.209 L14.6749,22.689 L15.7959,22.689 L15.7959,19.771 Z",
    id: "Fill-603",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6748,23.292 L14.6748,23.293 C14.6748,23.427 14.6988,23.559 14.7358,23.689 L14.8368,23.689 C14.7758,23.559 14.7118,23.429 14.6748,23.292",
    id: "Fill-605",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7031,23.6895 C40.7401,23.5585 40.7651,23.4265 40.7651,23.2935 L40.7651,23.1995 C40.7251,23.3685 40.6631,23.5305 40.5881,23.6895 L40.7031,23.6895 Z",
    id: "Fill-607",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6113,22.6895 L40.7643,22.6895 L40.7643,22.2605 C40.3853,22.2265 40.0023,22.1965 39.6113,22.1735 L39.6113,22.6895 Z",
    id: "Fill-609",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6133,22.123 C38.6643,22.125 38.7133,22.129 38.7643,22.131 L38.7643,20.337 C38.7153,20.365 38.6643,20.393 38.6133,20.42 L38.6133,22.123 Z",
    id: "Fill-611",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2715,25.0767 C28.8255,25.2047 28.4265,25.3367 28.0765,25.4707 C28.4855,25.4667 28.8845,25.4577 29.2715,25.4427 L29.2715,25.0767 Z",
    id: "Fill-613",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7578,23.0303 L16.7578,20.3903 C16.7298,20.3753 16.7018,20.3603 16.6748,20.3443 L16.6748,22.9103 C16.6978,22.9493 16.7228,22.9883 16.7578,23.0303",
    id: "Fill-615",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2715,25.3916 C31.4495,25.3116 32.5045,25.1796 33.4425,25.0136 L33.4425,24.2996 C32.2405,24.4286 31.1795,24.6086 30.2715,24.8186 L30.2715,25.3916 Z",
    id: "Fill-617",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6309,25.3477 C24.7579,25.1797 24.9139,25.0157 25.0999,24.8557 L25.0999,22.3047 C24.0149,22.2327 22.9449,22.1177 21.9289,21.9537 L21.9289,25.0047 C22.7359,25.1497 23.6429,25.2647 24.6309,25.3477",
    id: "Fill-619",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2715,23.0063 L29.2715,22.3593 C28.7505,22.3793 28.2305,22.3933 27.7115,22.3933 C27.1755,22.3933 26.6375,22.3783 26.0995,22.3563 L26.0995,24.1823 C26.9295,23.7283 28.0045,23.3303 29.2715,23.0063",
    id: "Fill-621",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4424,22.2056 C35.3564,22.1386 36.3024,22.1016 37.2784,22.1016 C37.3914,22.1016 37.5014,22.1056 37.6134,22.1066 L37.6134,20.8856 C36.6884,21.2536 35.6114,21.5506 34.4424,21.7826 L34.4424,22.2056 Z",
    id: "Fill-623",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4424,22.2896 L33.4424,21.9616 C32.4244,22.1236 31.3554,22.2386 30.2714,22.3086 L30.2714,22.7746 C31.2494,22.5696 32.3104,22.4036 33.4424,22.2896",
    id: "Fill-625",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9287,24.8037 L20.9287,21.7727 C19.7567,21.5377 18.6807,21.2357 17.7577,20.8627 L17.7577,23.7357 C18.4817,24.1077 19.5377,24.4917 20.9287,24.8037",
    id: "Fill-627",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8281,24.1079 C35.9831,24.1179 35.1881,24.1529 34.4421,24.2099 L34.4421,24.8159 C35.3931,24.6059 36.1831,24.3599 36.8281,24.1079",
    id: "Fill-629",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4424,24.2998 L33.4424,22.2898 C32.3104,22.4038 31.2494,22.5698 30.2714,22.7748 L30.2714,24.8188 C31.1794,24.6088 32.2404,24.4278 33.4424,24.2998",
    id: "Fill-631",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6133,23.0869 C38.6783,23.0189 38.7293,22.9529 38.7643,22.8909 L38.7643,22.1309 C38.7133,22.1289 38.6643,22.1249 38.6133,22.1229 L38.6133,23.0869 Z",
    id: "Fill-633",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2783,22.1011 C36.3023,22.1011 35.3563,22.1391 34.4423,22.2051 L34.4423,24.2091 C35.1883,24.1531 35.9833,24.1181 36.8283,24.1081 C37.1223,23.9931 37.3833,23.8771 37.6133,23.7611 L37.6133,22.1061 C37.5013,22.1051 37.3913,22.1011 37.2783,22.1011",
    id: "Fill-635",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7119,25.4761 C27.8369,25.4761 27.9529,25.4711 28.0759,25.4701 C28.4269,25.3371 28.8249,25.2051 29.2719,25.0771 L29.2719,23.0061 C28.0049,23.3301 26.9299,23.7281 26.0999,24.1821 L26.0999,25.4401 C26.6189,25.4611 27.1509,25.4761 27.7119,25.4761",
    id: "Fill-637",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0996,24.8555 C24.9136,25.0155 24.7576,25.1795 24.6306,25.3475 C24.7876,25.3605 24.9376,25.3765 25.0996,25.3885 L25.0996,24.8555 Z",
    id: "Fill-639",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6748,22.9106 L16.6748,20.3446 C16.3518,20.1646 16.0508,19.9756 15.7958,19.7706 L15.7958,22.6896 L16.5938,22.6896 C16.5938,22.7556 16.6268,22.8316 16.6748,22.9106",
    id: "Fill-641",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7646,22.1309 C39.0496,22.1419 39.3306,22.1569 39.6116,22.1729 L39.6116,19.7839 C39.3636,19.9809 39.0756,20.1629 38.7646,20.3369 L38.7646,22.1309 Z",
    id: "Fill-643",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7959,16.7319 L15.7959,17.6069 L16.1279,17.6069 C15.9189,17.3259 15.7959,17.0339 15.7959,16.7319",
    id: "Fill-645",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6113,16.7319 C39.6113,17.0339 39.4883,17.3259 39.2783,17.6069 L39.6113,17.6069 L39.6113,16.7319 Z",
    id: "Fill-647",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7646,22.8906 C38.8046,22.8186 38.8306,22.7506 38.8306,22.6896 L39.6116,22.6896 L39.6116,22.1736 C39.3306,22.1566 39.0496,22.1416 38.7646,22.1306 L38.7646,22.8906 Z",
    id: "Fill-649",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7578,26.7012 L17.1978,26.7012 C17.0428,26.6282 16.9008,26.5512 16.7578,26.4732 L16.7578,26.7012 Z",
    id: "Fill-651",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7578,18.0244 L16.8328,18.0244 C17.0248,18.2184 17.3298,18.4324 17.7578,18.6524 L17.7578,18.0244 Z",
    id: "Fill-653",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7578,23.7354 L17.7578,20.8624 C17.3978,20.7164 17.0668,20.5584 16.7578,20.3904 L16.7578,23.0304 C16.9388,23.2434 17.2738,23.4864 17.7578,23.7354",
    id: "Fill-655",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9287,18.0244 L20.9287,18.0244 L20.9287,19.7204 C21.2447,19.7924 21.5777,19.8594 21.9287,19.9214 L21.9287,18.0244 Z",
    id: "Fill-657",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9287,21.9541 C21.5887,21.8991 21.2557,21.8381 20.9287,21.7721 L20.9287,24.8041 C21.2447,24.8751 21.5777,24.9421 21.9287,25.0051 L21.9287,21.9541 Z",
    id: "Fill-659",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0996,18.0244 L25.0996,18.0244 L25.0996,20.3054 C25.4216,20.3274 25.7596,20.3424 26.0996,20.3574 L26.0996,18.0244 Z",
    id: "Fill-661",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0996,24.1821 L26.0996,22.3561 C25.7656,22.3431 25.4316,22.3271 25.0996,22.3051 L25.0996,24.8551 C25.3736,24.6201 25.7086,24.3951 26.0996,24.1821",
    id: "Fill-663",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0996,25.4399 L26.0996,24.1819 C25.7086,24.3959 25.3736,24.6199 25.0996,24.8559 L25.0996,25.3879 C25.4216,25.4099 25.7596,25.4259 26.0996,25.4399",
    id: "Fill-665",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2715,18.0244 L29.2715,18.0244 L29.2715,20.3594 C29.6125,20.3454 29.9495,20.3304 30.2715,20.3084 L30.2715,18.0244 Z",
    id: "Fill-667",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2715,22.7744 L30.2715,22.3084 C29.9395,22.3304 29.6055,22.3454 29.2715,22.3584 L29.2715,23.0064 C29.5935,22.9244 29.9265,22.8464 30.2715,22.7744",
    id: "Fill-669",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2715,25.3916 L30.2715,24.8186 C29.9145,24.9006 29.5835,24.9876 29.2715,25.0766 L29.2715,25.4426 C29.6125,25.4286 29.9495,25.4136 30.2715,25.3916",
    id: "Fill-671",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2715,24.8184 L30.2715,22.7744 C29.9265,22.8464 29.5935,22.9244 29.2715,23.0064 L29.2715,25.0764 C29.5835,24.9874 29.9145,24.9014 30.2715,24.8184",
    id: "Fill-673",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4424,18.0244 L33.4424,18.0244 L33.4424,19.9304 C33.7914,19.8694 34.1274,19.8034 34.4424,19.7334 L34.4424,18.0244 Z",
    id: "Fill-675",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4424,22.2056 L34.4424,21.7826 C34.1154,21.8466 33.7824,21.9076 33.4424,21.9616 L33.4424,22.2896 C33.7694,22.2566 34.1044,22.2296 34.4424,22.2056",
    id: "Fill-677",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4424,25.0137 C33.7914,24.9517 34.1274,24.8867 34.4424,24.8167 L34.4424,24.2097 C34.0984,24.2357 33.7654,24.2657 33.4424,24.2997 L33.4424,25.0137 Z",
    id: "Fill-679",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4424,24.2998 C33.7654,24.2658 34.0984,24.2358 34.4424,24.2098 L34.4424,22.2058 C34.1044,22.2298 33.7694,22.2568 33.4424,22.2898 L33.4424,24.2998 Z",
    id: "Fill-681",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6133,18.0244 L37.6133,18.6784 C38.0673,18.4494 38.3933,18.2264 38.5923,18.0244 L37.6133,18.0244 Z",
    id: "Fill-683",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6133,26.7012 L38.6133,26.5022 C38.4873,26.5702 38.3623,26.6382 38.2263,26.7012 L38.6133,26.7012 Z",
    id: "Fill-685",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6133,22.123 L38.6133,20.42 C38.3023,20.585 37.9733,20.742 37.6133,20.886 L37.6133,22.106 C37.9493,22.109 38.2843,22.112 38.6133,22.123",
    id: "Fill-687",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6133,23.7612 C38.0823,23.5252 38.4173,23.2942 38.6133,23.0872 L38.6133,22.1232 C38.2843,22.1122 37.9493,22.1092 37.6133,22.1062 L37.6133,23.7612 Z",
    id: "Fill-689",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4424,20.0488 L33.4424,19.9308 C32.5054,20.0958 31.4494,20.2288 30.2714,20.3088 L30.2714,20.4278 C31.3964,20.3488 32.4624,20.2208 33.4424,20.0488",
    id: "Fill-691",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9287,19.8437 L20.9287,19.7207 C19.5377,19.4077 18.4817,19.0247 17.7577,18.6527 L17.7577,18.8117 C18.5977,19.2167 19.6747,19.5677 20.9287,19.8437",
    id: "Fill-693",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7031,20.5181 C28.2361,20.5181 28.7571,20.5031 29.2711,20.4811 L29.2711,20.3591 C28.7681,20.3791 28.2531,20.3931 27.7121,20.3931 C27.1511,20.3931 26.6191,20.3781 26.0991,20.3571 L26.0991,20.4801 C26.6251,20.5021 27.1581,20.5181 27.7031,20.5181",
    id: "Fill-695",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0996,20.4248 L25.0996,20.3048 C23.9216,20.2238 22.8656,20.0898 21.9286,19.9218 L21.9286,20.0418 C22.9096,20.2158 23.9746,20.3448 25.0996,20.4248",
    id: "Fill-697",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5918,18.0244 L38.6128,18.0244 L38.6128,18.2464 C38.6668,18.2074 38.7148,18.1684 38.7648,18.1284 L38.7648,17.8074 C38.7258,17.8764 38.6668,17.9484 38.5918,18.0244",
    id: "Fill-699",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7578,18.2231 L16.7578,18.0241 L16.8328,18.0241 C16.7658,17.9561 16.7118,17.8901 16.6748,17.8271 L16.6748,18.1561 C16.7028,18.1781 16.7288,18.2011 16.7578,18.2231",
    id: "Fill-701",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6133,18.8301 L37.6133,18.6781 C36.8823,19.0471 35.8273,19.4261 34.4423,19.7331 L34.4423,19.8521 C35.6923,19.5791 36.7703,19.2311 37.6133,18.8301",
    id: "Fill-703",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6113,19.7837 C40.2193,19.2997 40.6213,18.7447 40.7643,18.1167 L40.7643,17.6067 L39.6113,17.6067 L39.6113,19.7837 Z",
    id: "Fill-705",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7959,19.771 L15.7959,17.607 L14.6749,17.607 L14.6749,18.209 C14.8329,18.794 15.2259,19.313 15.7959,19.771",
    id: "Fill-707",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6748,18.1562 L16.6748,17.8272 C16.6268,17.7492 16.5938,17.6732 16.5938,17.6072 L16.1278,17.6072 C16.2688,17.7962 16.4478,17.9792 16.6748,18.1562",
    id: "Fill-709",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2783,17.6069 L38.8313,17.6069 C38.8313,17.6679 38.8043,17.7359 38.7643,17.8079 L38.7643,18.1279 C38.9743,17.9599 39.1453,17.7859 39.2783,17.6069",
    id: "Fill-711",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7578,18.2231 C16.7288,18.2011 16.7028,18.1781 16.6748,18.1561 L16.6748,20.3451 C16.7018,20.3601 16.7298,20.3751 16.7578,20.3901 L16.7578,18.2231 Z",
    id: "Fill-713",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7646,20.3369 L38.7646,18.1289 C38.7146,18.1679 38.6666,18.2079 38.6136,18.2469 L38.6136,20.4199 C38.6636,20.3929 38.7146,20.3649 38.7646,20.3369",
    id: "Fill-715",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6133,20.8857 L37.6133,18.8297 C36.7703,19.2317 35.6923,19.5787 34.4423,19.8517 L34.4423,21.7817 C35.6113,21.5507 36.6883,21.2537 37.6133,20.8857",
    id: "Fill-717",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0996,22.3047 L25.0996,20.4247 C23.9746,20.3447 22.9096,20.2157 21.9286,20.0417 L21.9286,21.9537 C22.9456,22.1177 24.0146,22.2327 25.0996,22.3047",
    id: "Fill-719",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7119,22.3931 C28.2309,22.3931 28.7509,22.3791 29.2719,22.3591 L29.2719,20.4811 C28.7569,20.5031 28.2359,20.5181 27.7029,20.5181 C27.1579,20.5181 26.6249,20.5021 26.0999,20.4801 L26.0999,22.3561 C26.6379,22.3781 27.1759,22.3931 27.7119,22.3931",
    id: "Fill-721",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9287,19.8437 C19.6747,19.5677 18.5977,19.2167 17.7577,18.8117 L17.7577,20.8627 C18.6807,21.2357 19.7567,21.5377 20.9287,21.7727 L20.9287,19.8437 Z",
    id: "Fill-723",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4424,21.9614 L33.4424,20.0484 C32.4624,20.2204 31.3964,20.3484 30.2714,20.4274 L30.2714,22.3084 C31.3554,22.2384 32.4244,22.1234 33.4424,21.9614",
    id: "Fill-725",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7646,18.1284 L38.7646,20.3364 C39.0756,20.1634 39.3636,19.9814 39.6116,19.7834 L39.6116,17.6074 L39.2786,17.6074 C39.1456,17.7864 38.9746,17.9604 38.7646,18.1284",
    id: "Fill-727",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6748,20.3447 L16.6748,18.1567 C16.4478,17.9797 16.2688,17.7957 16.1278,17.6067 L15.7958,17.6067 L15.7958,19.7707 C16.0508,19.9757 16.3518,20.1647 16.6748,20.3447",
    id: "Fill-729",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7578,18.6523 C17.3298,18.4323 17.0248,18.2183 16.8328,18.0243 L16.7578,18.0243 L16.7578,18.2233 C17.0358,18.4293 17.3728,18.6263 17.7578,18.8113 L17.7578,18.6523 Z",
    id: "Fill-731",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7578,20.8623 L17.7578,18.8113 C17.3728,18.6263 17.0358,18.4293 16.7578,18.2233 L16.7578,20.3903 C17.0668,20.5583 17.3978,20.7163 17.7578,20.8623",
    id: "Fill-733",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9287,20.042 L21.9287,19.922 C21.5777,19.859 21.2447,19.792 20.9287,19.721 L20.9287,19.844 C21.2507,19.915 21.5837,19.981 21.9287,20.042",
    id: "Fill-735",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9287,21.9541 L21.9287,20.0421 C21.5837,19.9811 21.2507,19.9151 20.9287,19.8441 L20.9287,21.7721 C21.2557,21.8381 21.5887,21.8991 21.9287,21.9541",
    id: "Fill-737",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0996,20.48 L26.0996,20.357 C25.7596,20.343 25.4216,20.327 25.0996,20.305 L25.0996,20.425 C25.4276,20.448 25.7616,20.465 26.0996,20.48",
    id: "Fill-739",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0996,22.3564 L26.0996,20.4804 C25.7616,20.4654 25.4276,20.4474 25.0996,20.4244 L25.0996,22.3044 C25.4316,22.3264 25.7656,22.3424 26.0996,22.3564",
    id: "Fill-741",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2715,20.4277 L30.2715,20.3087 C29.9495,20.3307 29.6125,20.3457 29.2715,20.3597 L29.2715,20.4817 C29.6095,20.4677 29.9435,20.4507 30.2715,20.4277",
    id: "Fill-743",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2715,22.3086 L30.2715,20.4276 C29.9435,20.4506 29.6095,20.4676 29.2715,20.4816 L29.2715,22.3586 C29.6055,22.3456 29.9395,22.3296 30.2715,22.3086",
    id: "Fill-745",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4424,19.8521 L34.4424,19.7331 C34.1274,19.8041 33.7914,19.8691 33.4424,19.9311 L33.4424,20.0491 C33.7874,19.9891 34.1204,19.9231 34.4424,19.8521",
    id: "Fill-747",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4424,21.7822 L34.4424,19.8522 C34.1204,19.9232 33.7874,19.9892 33.4424,20.0492 L33.4424,21.9612 C33.7824,21.9072 34.1154,21.8462 34.4424,21.7822",
    id: "Fill-749",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6133,18.2466 L38.6133,18.0246 L38.5923,18.0246 C38.3933,18.2256 38.0673,18.4496 37.6133,18.6786 L37.6133,18.8296 C37.9993,18.6466 38.3323,18.4516 38.6133,18.2466",
    id: "Fill-751",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6133,20.8857 C37.9733,20.7417 38.3023,20.5847 38.6133,20.4197 L38.6133,18.2467 C38.3323,18.4507 37.9993,18.6467 37.6133,18.8297 L37.6133,20.8857 Z",
    id: "Fill-753",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6133,26.0757 C35.2203,26.9897 31.6793,27.5707 27.7193,27.5707 C27.2583,27.5707 26.8013,27.5617 26.3523,27.5467 C26.3633,27.5587 26.3803,27.5717 26.3913,27.5837 L27.3163,27.5837 L27.3163,28.2117 C27.4863,28.2987 27.6773,28.3867 27.8843,28.4737 C28.7513,28.4697 29.6233,28.4357 30.4873,28.3747 L30.4873,27.5837 L31.4873,27.5837 L31.4873,28.2927 C32.5883,28.1847 33.6593,28.0307 34.6593,27.8247 L34.6593,27.5837 L35.6593,27.5837 L35.6593,27.5947 C36.6173,27.3497 37.4833,27.0517 38.2263,26.7007 L37.6133,26.7007 L37.6133,26.0757 Z",
    id: "Fill-755",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7354,23.6895 L14.6744,23.6895 L14.6744,24.2925 C14.9104,25.1615 15.6684,25.8825 16.7574,26.4735 L16.7574,25.6065 C15.6514,25.0435 14.9324,24.3915 14.7354,23.6895",
    id: "Fill-757",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6133,25.6426 L38.6133,26.5026 C39.7463,25.8996 40.5263,25.1576 40.7573,24.2606 C40.6533,24.2506 40.5423,24.2436 40.4363,24.2346 C40.0873,24.7446 39.4643,25.2196 38.6133,25.6426",
    id: "Fill-759",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1836,27.4067 C21.6426,27.1727 19.4156,26.6947 17.7576,26.0517 L17.7576,26.7007 L17.1986,26.7007 C18.9926,27.5467 21.5306,28.0797 24.2336,28.3227 L24.2336,27.7687 C24.2016,27.6517 24.1976,27.5287 24.1836,27.4067",
    id: "Fill-761",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2334,27.7686 L24.2334,28.3226 C24.3134,28.3296 24.3944,28.3336 24.4744,28.3406 C24.3704,28.1566 24.2874,27.9666 24.2334,27.7686",
    id: "Fill-763",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7568,24.2603 C40.8038,24.0763 40.8308,23.8863 40.8308,23.6893 L40.7028,23.6893 C40.6518,23.8753 40.5588,24.0563 40.4368,24.2353 C40.5418,24.2433 40.6528,24.2503 40.7568,24.2603",
    id: "Fill-765",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3164,27.5835 L26.3914,27.5835 C26.5834,27.7775 26.8884,27.9915 27.3164,28.2115 L27.3164,27.5835 Z",
    id: "Fill-767",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4873,27.5835 L30.4873,27.5835 L30.4873,28.3755 C30.8223,28.3515 31.1563,28.3245 31.4873,28.2925 L31.4873,27.5835 Z",
    id: "Fill-769",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6592,27.5835 L34.6592,27.8245 C35.0012,27.7535 35.3352,27.6765 35.6592,27.5945 L35.6592,27.5835 L34.6592,27.5835 Z",
    id: "Fill-771",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3916,27.5835 C26.3796,27.5715 26.3636,27.5585 26.3526,27.5465 C26.3126,27.5445 26.2736,27.5415 26.2336,27.5405 L26.2336,27.7145 C26.2616,27.7365 26.2876,27.7595 26.3166,27.7815 L26.3166,27.5835 L26.3916,27.5835 Z",
    id: "Fill-773",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1836,27.4067 C24.1976,27.5287 24.2016,27.6517 24.2336,27.7687 L24.2336,27.4107 C24.2166,27.4087 24.2006,27.4077 24.1836,27.4067",
    id: "Fill-775",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.543,28.4736 C27.6,28.4736 27.656,28.4756 27.712,28.4756 C27.769,28.4756 27.826,28.4736 27.884,28.4736 C27.678,28.3866 27.486,28.2986 27.316,28.2116 L27.316,28.3696 C27.39,28.4056 27.467,28.4386 27.543,28.4736",
    id: "Fill-777",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3545,27.4966 C24.9745,27.4736 24.6015,27.4446 24.2335,27.4116 L24.2335,27.7686 C24.2875,27.9666 24.3705,28.1566 24.4745,28.3406 C24.7665,28.3646 25.0595,28.3886 25.3545,28.4066 L25.3545,27.4966 Z",
    id: "Fill-779",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0205,27.5298 C26.0875,27.5918 26.1555,27.6548 26.2335,27.7148 L26.2335,27.5408 C26.1615,27.5378 26.0915,27.5328 26.0205,27.5298",
    id: "Fill-781",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3164,27.7817 C26.2874,27.7597 26.2614,27.7367 26.2334,27.7147 L26.2334,28.4457 C26.2604,28.4467 26.2894,28.4487 26.3164,28.4487 L26.3164,27.7817 Z",
    id: "Fill-783",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3164,28.3701 L27.3164,28.4701 C27.3914,28.4711 27.4674,28.4731 27.5434,28.4741 C27.4664,28.4391 27.3894,28.4051 27.3164,28.3701",
    id: "Fill-785",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0205,27.5298 C25.7965,27.5198 25.5745,27.5098 25.3545,27.4968 L25.3545,28.4058 C25.6465,28.4238 25.9405,28.4348 26.2335,28.4458 L26.2335,27.7148 C26.1555,27.6548 26.0875,27.5918 26.0205,27.5298",
    id: "Fill-787",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3164,28.2114 C26.8884,27.9914 26.5834,27.7774 26.3914,27.5834 L26.3164,27.5834 L26.3164,27.7814 C26.5944,27.9884 26.9314,28.1844 27.3164,28.3704 L27.3164,28.2114 Z",
    id: "Fill-789",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3164,28.3701 C26.9314,28.1841 26.5944,27.9881 26.3164,27.7821 L26.3164,28.4491 C26.6504,28.4611 26.9834,28.4671 27.3164,28.4701 L27.3164,28.3701 Z",
    id: "Fill-791",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7578,25.9453 L17.7578,26.0513 C19.4158,26.6943 21.6428,27.1723 24.1838,27.4063 C24.1808,27.3773 24.1738,27.3473 24.1718,27.3173 C21.7618,27.0973 19.4878,26.6443 17.7578,25.9453",
    id: "Fill-793",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8369,23.6895 L14.7349,23.6895 C14.9329,24.3915 15.6509,25.0435 16.7579,25.6065 L16.7579,25.4735 C15.8399,24.9765 15.1679,24.3835 14.8369,23.6895",
    id: "Fill-795",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6133,25.5024 L38.6133,25.6424 C39.4643,25.2194 40.0873,24.7444 40.4363,24.2344 C40.3773,24.2294 40.3153,24.2254 40.2563,24.2204 C39.8743,24.7044 39.3123,25.1304 38.6133,25.5024",
    id: "Fill-797",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2754,27.4473 C26.2994,27.4803 26.3204,27.5123 26.3524,27.5463 C26.8014,27.5613 27.2574,27.5703 27.7194,27.5703 C31.6794,27.5703 35.2204,26.9893 37.6134,26.0753 L37.6134,25.9683 C35.0474,26.9903 31.3034,27.4763 27.7124,27.4763 C27.2344,27.4763 26.7544,27.4643 26.2754,27.4473",
    id: "Fill-799",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2559,24.2207 C40.3159,24.2257 40.3769,24.2297 40.4369,24.2347 C40.5589,24.0567 40.6519,23.8747 40.7029,23.6897 L40.5879,23.6897 C40.4999,23.8737 40.3899,24.0507 40.2559,24.2207",
    id: "Fill-801",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2754,27.4473 C26.2614,27.4473 26.2474,27.4463 26.2334,27.4453 L26.2334,27.5403 C26.2734,27.5423 26.3124,27.5453 26.3524,27.5463 C26.3204,27.5123 26.2994,27.4803 26.2754,27.4473",
    id: "Fill-803",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2334,27.3223 C24.2124,27.3203 24.1924,27.3193 24.1714,27.3173 C24.1734,27.3473 24.1804,27.3773 24.1834,27.4063 C24.2004,27.4083 24.2164,27.4093 24.2334,27.4113 L24.2334,27.3223 Z",
    id: "Fill-805",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2334,27.3223 L24.2334,27.4113 C24.6014,27.4443 24.9744,27.4733 25.3544,27.4963 L25.3544,27.4063 C24.9784,27.3843 24.6044,27.3553 24.2334,27.3223",
    id: "Fill-807",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2334,27.4453 C26.1244,27.4413 26.0154,27.4353 25.9064,27.4303 C25.9394,27.4643 25.9844,27.4963 26.0204,27.5293 C26.0914,27.5323 26.1614,27.5373 26.2334,27.5403 L26.2334,27.4453 Z",
    id: "Fill-809",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9063,27.4307 C25.7223,27.4227 25.5383,27.4167 25.3543,27.4067 L25.3543,27.4967 C25.5743,27.5097 25.7973,27.5197 26.0203,27.5297 C25.9843,27.4967 25.9393,27.4647 25.9063,27.4307",
    id: "Fill-811",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7578,26.0513 C17.3958,25.9103 17.0638,25.7613 16.7578,25.6063 L16.7578,26.4733 C16.9008,26.5513 17.0428,26.6283 17.1978,26.7013 L17.7578,26.7013 L17.7578,26.0513 Z",
    id: "Fill-813",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7578,25.4731 L16.7578,25.6061 C17.0638,25.7621 17.3958,25.9101 17.7578,26.0511 L17.7578,25.9451 C17.3978,25.7991 17.0668,25.6401 16.7578,25.4731",
    id: "Fill-815",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6133,26.7012 L38.2263,26.7012 C38.3623,26.6382 38.4873,26.5702 38.6133,26.5022 L38.6133,25.6422 C38.3083,25.7942 37.9723,25.9382 37.6133,26.0762 L37.6133,26.7012 Z",
    id: "Fill-817",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6133,25.9683 L37.6133,26.0753 C37.9723,25.9383 38.3083,25.7943 38.6133,25.6423 L38.6133,25.5023 C38.3023,25.6673 37.9733,25.8243 37.6133,25.9683",
    id: "Fill-819",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8311,22.6895 L40.7651,22.6895 L40.7651,23.1995 C40.8021,23.0345 40.8311,22.8655 40.8311,22.6895",
    id: "Fill-821",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7246,26.2583 C32.3336,26.1893 32.9106,26.1083 33.4426,26.0133 L33.4426,25.8603 C32.8576,26.0183 32.2866,26.1463 31.7246,26.2583",
    id: "Fill-823",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6133,24.7612 L37.6133,24.3732 C36.5283,24.8512 35.4683,25.2492 34.4423,25.5682 L34.4423,25.8162 C35.8273,25.5092 36.8823,25.1302 37.6133,24.7612",
    id: "Fill-825",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7959,23.6895 L15.7959,22.6895 L14.6749,22.6895 L14.6749,23.2925 C14.7119,23.4295 14.7749,23.5595 14.8369,23.6895 L15.7959,23.6895 Z",
    id: "Fill-827",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0684,23.6895 L40.5884,23.6895 C40.6634,23.5305 40.7254,23.3685 40.7644,23.1995 L40.7644,22.6895 L39.6114,22.6895 L39.6114,23.4205 C39.4284,23.5155 39.2494,23.5985 39.0684,23.6895",
    id: "Fill-829",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7959,23.8247 C38.7349,23.8547 38.6739,23.8857 38.6129,23.9147 L38.6129,24.0867 C38.7019,23.9937 38.7629,23.9057 38.7959,23.8247",
    id: "Fill-831",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9287,25.0049 L21.9287,25.0969 C22.7197,25.2369 23.5967,25.3539 24.5607,25.4369 C24.5807,25.4069 24.6087,25.3779 24.6307,25.3479 C23.6427,25.2649 22.7367,25.1499 21.9287,25.0049",
    id: "Fill-833",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2715,25.4424 C28.8845,25.4584 28.4855,25.4664 28.0765,25.4704 C27.9895,25.5034 27.9065,25.5354 27.8255,25.5684 C28.3255,25.5674 28.8045,25.5544 29.2715,25.5364 L29.2715,25.4424 Z",
    id: "Fill-835",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2715,25.4839 C31.4495,25.4039 32.5035,25.2729 33.4425,25.1089 L33.4425,25.0139 C32.5045,25.1789 31.4495,25.3119 30.2715,25.3919 L30.2715,25.4839 Z",
    id: "Fill-837",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9287,24.8037 C19.5377,24.4917 18.4817,24.1077 17.7577,23.7357 L17.7577,23.8797 C18.4807,24.2257 19.5417,24.5937 20.9287,24.8997 L20.9287,24.8037 Z",
    id: "Fill-839",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6748,22.9106 L16.6748,23.1536 C16.6958,23.1816 16.7288,23.2116 16.7578,23.2416 L16.7578,23.0306 C16.7228,22.9886 16.6978,22.9496 16.6748,22.9106",
    id: "Fill-841",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4424,24.9146 C35.5644,24.6706 36.4774,24.3856 37.1714,24.1026 C37.0544,24.1026 36.9434,24.1066 36.8284,24.1076 C36.1834,24.3606 35.3934,24.6056 34.4424,24.8166 L34.4424,24.9146 Z",
    id: "Fill-843",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6309,25.3477 C24.6089,25.3777 24.5809,25.4067 24.5609,25.4367 C24.7379,25.4517 24.9169,25.4657 25.0999,25.4787 L25.0999,25.3887 C24.9379,25.3767 24.7879,25.3607 24.6309,25.3477",
    id: "Fill-845",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8252,25.5684 C27.9062,25.5354 27.9892,25.5034 28.0762,25.4704 C27.9532,25.4714 27.8372,25.4764 27.7122,25.4764 C27.1512,25.4764 26.6192,25.4614 26.0992,25.4404 L26.0992,25.5334 C26.6212,25.5544 27.1562,25.5704 27.7202,25.5704 C27.7562,25.5704 27.7892,25.5684 27.8252,25.5684",
    id: "Fill-847",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1719,24.1025 C37.3309,24.0385 37.4779,23.9745 37.6129,23.9105 L37.6129,23.7615 C37.3839,23.8765 37.1219,23.9925 36.8279,24.1075 C36.9429,24.1065 37.0549,24.1025 37.1719,24.1025",
    id: "Fill-849",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6133,23.0869 L38.6133,23.3119 C38.6763,23.2549 38.7273,23.2029 38.7643,23.1539 L38.7643,22.8909 C38.7293,22.9529 38.6783,23.0189 38.6133,23.0869",
    id: "Fill-851",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7578,23.8799 L17.7578,24.7349 C18.4818,25.1079 19.5378,25.4909 20.9288,25.8039 L20.9288,24.8999 C19.5418,24.5939 18.4808,24.2259 17.7578,23.8799",
    id: "Fill-853",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7578,24.0303 L16.7578,23.2413 C16.7288,23.2123 16.6958,23.1813 16.6748,23.1543 L16.6748,22.9103 C16.6268,22.8313 16.5938,22.7563 16.5938,22.6893 L15.7958,22.6893 L15.7958,23.6893 L16.5938,23.6893 C16.5938,23.7883 16.6518,23.9043 16.7578,24.0303",
    id: "Fill-855",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4424,25.1094 C32.5044,25.2734 31.4494,25.4044 30.2714,25.4844 L30.2714,26.3914 C30.7804,26.3574 31.2594,26.3104 31.7244,26.2584 C32.2874,26.1464 32.8574,26.0184 33.4424,25.8604 L33.4424,25.1094 Z",
    id: "Fill-857",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1719,24.1025 C36.4779,24.3855 35.5649,24.6705 34.4429,24.9145 L34.4429,25.5675 C35.4689,25.2495 36.5279,24.8515 37.6129,24.3735 L37.6129,24.1065 C37.4999,24.1055 37.3929,24.1015 37.2779,24.1015 C37.2419,24.1015 37.2079,24.1025 37.1719,24.1025",
    id: "Fill-859",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8252,25.5684 C27.0322,25.8914 26.5222,26.2064 26.2972,26.4494 C26.7542,26.4664 27.2232,26.4764 27.7122,26.4764 C28.2532,26.4764 28.7682,26.4624 29.2712,26.4424 L29.2712,25.5364 C28.8042,25.5544 28.3252,25.5674 27.8252,25.5684",
    id: "Fill-861",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9287,25.0972 L21.9287,26.0052 C22.6297,26.1302 23.4067,26.2352 24.2427,26.3142 C24.2567,26.0132 24.3667,25.7202 24.5607,25.4362 C23.5967,25.3542 22.7197,25.2372 21.9287,25.0972",
    id: "Fill-863",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5605,25.4365 C24.3665,25.7195 24.2565,26.0135 24.2435,26.3145 C24.5235,26.3415 24.8045,26.3675 25.0995,26.3885 L25.0995,25.4785 C24.9165,25.4655 24.7385,25.4515 24.5605,25.4365",
    id: "Fill-865",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2783,24.1011 C37.3923,24.1011 37.5003,24.1051 37.6133,24.1061 L37.6133,23.9111 C37.4773,23.9741 37.3313,24.0381 37.1723,24.1021 C37.2083,24.1021 37.2423,24.1011 37.2783,24.1011",
    id: "Fill-867",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8252,25.5684 C27.7892,25.5684 27.7562,25.5704 27.7202,25.5704 C27.1562,25.5704 26.6212,25.5544 26.0992,25.5334 L26.0992,26.4404 C26.1672,26.4424 26.2292,26.4474 26.2972,26.4494 C26.5222,26.2064 27.0322,25.8914 27.8252,25.5684",
    id: "Fill-869",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7646,22.8906 L38.7646,23.1536 C38.7276,23.2026 38.6766,23.2556 38.6136,23.3116 L38.6136,23.9146 C38.6736,23.8856 38.7356,23.8546 38.7956,23.8246 C38.8146,23.7776 38.8306,23.7316 38.8306,23.6896 L39.0686,23.6896 C39.2486,23.5986 39.4286,23.5156 39.6116,23.4206 L39.6116,22.6896 L38.8306,22.6896 C38.8306,22.7506 38.8046,22.8186 38.7646,22.8906",
    id: "Fill-871",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7578,23.8799 L17.7578,23.7349 C17.2738,23.4859 16.9388,23.2429 16.7578,23.0299 L16.7578,23.2419 C16.9368,23.4249 17.2678,23.6459 17.7578,23.8799",
    id: "Fill-873",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7578,24.7354 L17.7578,23.8804 C17.2678,23.6454 16.9368,23.4244 16.7578,23.2414 L16.7578,24.0304 C16.9388,24.2434 17.2738,24.4864 17.7578,24.7354",
    id: "Fill-875",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9287,25.0972 L21.9287,25.0052 C21.5777,24.9422 21.2447,24.8752 20.9287,24.8042 L20.9287,24.9002 C21.2447,24.9702 21.5777,25.0352 21.9287,25.0972",
    id: "Fill-877",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9287,24.8999 L20.9287,25.8039 C21.2447,25.8749 21.5777,25.9419 21.9287,26.0049 L21.9287,25.0969 C21.5777,25.0349 21.2447,24.9699 20.9287,24.8999",
    id: "Fill-879",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0996,25.3882 L25.0996,25.4782 C25.4226,25.5012 25.7576,25.5182 26.0996,25.5332 L26.0996,25.4402 C25.7596,25.4262 25.4216,25.4102 25.0996,25.3882",
    id: "Fill-881",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3545,26.2905 C25.3545,26.3285 25.3695,26.3655 25.3725,26.4025 C25.6095,26.4175 25.8525,26.4295 26.0995,26.4395 L26.0995,25.5335 C25.7575,25.5185 25.4225,25.5015 25.0995,25.4785 L25.0995,26.3885 C25.1825,26.3935 25.2705,26.3965 25.3545,26.4015 L25.3545,26.2905 Z",
    id: "Fill-883",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3545,26.2905 L25.3545,26.4015 C25.3605,26.4025 25.3665,26.4025 25.3725,26.4025 C25.3695,26.3655 25.3545,26.3285 25.3545,26.2905",
    id: "Fill-885",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2715,25.4424 L29.2715,25.5364 C29.6135,25.5224 29.9485,25.5054 30.2715,25.4844 L30.2715,25.3914 C29.9495,25.4134 29.6125,25.4284 29.2715,25.4424",
    id: "Fill-887",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2715,26.4424 C29.6125,26.4284 29.9495,26.4134 30.2715,26.3914 L30.2715,25.4844 C29.9485,25.5054 29.6135,25.5224 29.2715,25.5364 L29.2715,26.4424 Z",
    id: "Fill-889",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4424,26.0137 C33.7914,25.9517 34.1274,25.8867 34.4424,25.8167 L34.4424,25.5677 C34.1064,25.6727 33.7714,25.7717 33.4424,25.8607 L33.4424,26.0137 Z",
    id: "Fill-891",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4424,25.0137 L33.4424,25.1097 C33.7934,25.0487 34.1264,24.9837 34.4424,24.9147 L34.4424,24.8167 C34.1274,24.8867 33.7914,24.9517 33.4424,25.0137",
    id: "Fill-893",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4424,25.8604 C33.7714,25.7714 34.1064,25.6724 34.4424,25.5684 L34.4424,24.9144 C34.1264,24.9834 33.7934,25.0484 33.4424,25.1094 L33.4424,25.8604 Z",
    id: "Fill-895",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6133,24.7612 C38.0553,24.5382 38.3753,24.3212 38.5753,24.1232 C38.4513,24.1192 38.3223,24.1182 38.1963,24.1152 C38.0013,24.2062 37.8073,24.2882 37.6133,24.3732 L37.6133,24.7612 Z",
    id: "Fill-897",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5752,24.123 C38.5872,24.111 38.6012,24.099 38.6132,24.087 L38.6132,23.915 C38.4742,23.982 38.3352,24.051 38.1962,24.115 C38.3222,24.118 38.4512,24.119 38.5752,24.123",
    id: "Fill-899",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6133,23.7612 L37.6133,23.9102 C38.0753,23.6952 38.4133,23.4882 38.6133,23.3112 L38.6133,23.0872 C38.4173,23.2942 38.0823,23.5252 37.6133,23.7612",
    id: "Fill-901",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1963,24.1152 C38.0053,24.1112 37.8103,24.1082 37.6133,24.1062 L37.6133,24.3732 C37.8073,24.2882 38.0013,24.2062 38.1963,24.1152",
    id: "Fill-903",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6133,24.1064 C37.8103,24.1074 38.0053,24.1104 38.1963,24.1154 C38.3353,24.0514 38.4743,23.9814 38.6133,23.9154 L38.6133,23.3114 C38.4133,23.4874 38.0753,23.6954 37.6133,23.9104 L37.6133,24.1064 Z",
    id: "Fill-905",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2334,27.1655 L24.2334,26.5985 C23.4124,26.5045 22.6434,26.3705 21.9284,26.2125 L21.9284,26.7015 L20.9284,26.7015 L20.9284,25.9695 C19.6454,25.6235 18.5814,25.2125 17.7574,24.8395 L17.7574,25.9455 C19.4884,26.6445 21.7614,27.0975 24.1714,27.3175 C24.1694,27.2665 24.1524,27.2175 24.1524,27.1655 L24.2334,27.1655 Z",
    id: "Fill-907",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4424,25.8164 L34.4424,26.7014 L33.4424,26.7014 L33.4424,26.0134 C32.9104,26.1084 32.3344,26.1894 31.7244,26.2584 C31.2314,26.3564 30.7464,26.4414 30.2714,26.5074 L30.2714,26.7014 L29.2714,26.7014 L29.2714,26.6274 C28.2074,26.7324 27.1934,26.7644 26.2334,26.7374 L26.2334,27.3864 C26.2454,27.4064 26.2604,27.4264 26.2754,27.4474 C26.7554,27.4644 27.2344,27.4764 27.7124,27.4764 C31.3034,27.4764 35.0474,26.9904 37.6134,25.9684 L37.6134,24.7614 C36.8814,25.1304 35.8274,25.5084 34.4424,25.8164",
    id: "Fill-909",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6133,25.5024 C39.3123,25.1304 39.8743,24.7044 40.2563,24.2204 C39.7313,24.1784 39.1873,24.1444 38.6133,24.1254 L38.6133,25.5024 Z",
    id: "Fill-911",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7959,23.7842 L15.7959,23.6892 L14.8369,23.6892 C15.1679,24.3832 15.8399,24.9762 16.7579,25.4732 L16.7579,24.3502 C16.1309,24.0172 15.7959,23.7842 15.7959,23.7842",
    id: "Fill-913",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0996,26.7012 L25.0996,26.6812 C24.8046,26.6592 24.5166,26.6312 24.2336,26.5982 L24.2336,27.1652 L25.3546,27.1652 L25.3546,26.7012 L25.0996,26.7012 Z",
    id: "Fill-915",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6133,24.0869 L38.6133,24.1249 C39.1873,24.1449 39.7313,24.1789 40.2563,24.2209 C40.3893,24.0509 40.5003,23.8739 40.5883,23.6899 L39.0683,23.6899 C38.9773,23.7349 38.8863,23.7799 38.7963,23.8249 C38.7623,23.9059 38.7023,23.9939 38.6133,24.0869",
    id: "Fill-917",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4297,26.7012 L25.4277,26.7012 C25.4807,26.8592 25.5747,27.0132 25.6867,27.1652 L26.1527,27.1652 C26.1527,27.2322 26.1857,27.3072 26.2337,27.3872 L26.2337,26.7382 C25.9607,26.7302 25.6937,26.7182 25.4297,26.7012",
    id: "Fill-919",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4277,26.7012 L25.3547,26.7012 L25.3547,27.1652 L25.6867,27.1652 C25.5737,27.0132 25.4807,26.8592 25.4277,26.7012",
    id: "Fill-921",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1523,27.1655 C24.1523,27.2175 24.1693,27.2665 24.1723,27.3175 C24.1923,27.3195 24.2133,27.3205 24.2333,27.3225 L24.2333,27.1655 L24.1523,27.1655 Z",
    id: "Fill-923",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2334,27.3867 L26.2334,27.4457 C26.2474,27.4457 26.2614,27.4467 26.2754,27.4477 C26.2604,27.4267 26.2454,27.4067 26.2334,27.3867",
    id: "Fill-925",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3545,27.1655 L24.2335,27.1655 L24.2335,27.3225 C24.6045,27.3555 24.9785,27.3835 25.3545,27.4065 L25.3545,27.1655 Z",
    id: "Fill-927",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2334,27.3867 C26.1854,27.3077 26.1524,27.2317 26.1524,27.1657 L25.6864,27.1657 C25.7544,27.2547 25.8204,27.3447 25.9064,27.4307 C26.0154,27.4357 26.1244,27.4417 26.2334,27.4457 L26.2334,27.3867 Z",
    id: "Fill-929",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6865,27.1655 L25.3545,27.1655 L25.3545,27.4065 C25.5385,27.4165 25.7225,27.4225 25.9065,27.4305 C25.8205,27.3445 25.7535,27.2545 25.6865,27.1655",
    id: "Fill-931",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7578,24.7354 L17.7578,24.8394 C18.5808,25.2134 19.6458,25.6244 20.9288,25.9694 L20.9288,25.8034 C19.5378,25.4914 18.4818,25.1074 17.7578,24.7354",
    id: "Fill-933",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2715,26.5073 C30.7465,26.4413 31.2315,26.3563 31.7245,26.2583 C31.2595,26.3103 30.7805,26.3573 30.2715,26.3913 L30.2715,26.5073 Z",
    id: "Fill-935",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2432,26.3145 C23.4062,26.2345 22.6302,26.1305 21.9292,26.0045 L21.9292,26.2125 C22.6432,26.3705 23.4122,26.5045 24.2332,26.5985 L24.2332,26.3785 C24.2332,26.3565 24.2422,26.3355 24.2432,26.3145",
    id: "Fill-937",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7578,24.3506 L16.7578,24.0306 C16.6518,23.9046 16.5938,23.7886 16.5938,23.6896 L15.7958,23.6896 L15.7958,23.7846 C15.7958,23.7846 16.1308,24.0176 16.7578,24.3506",
    id: "Fill-939",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7119,26.4761 C27.2239,26.4761 26.7539,26.4661 26.2969,26.4501 C26.2759,26.4721 26.2489,26.4961 26.2329,26.5181 L26.2329,26.7381 C27.1929,26.7651 28.2069,26.7321 29.2719,26.6271 L29.2719,26.4421 C28.7689,26.4621 28.2529,26.4761 27.7119,26.4761",
    id: "Fill-941",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2969,26.4497 C26.2299,26.4477 26.1669,26.4427 26.0999,26.4397 L26.0999,26.7007 L25.4299,26.7007 C25.6929,26.7177 25.9609,26.7297 26.2339,26.7377 L26.2339,26.5177 C26.2489,26.4957 26.2759,26.4717 26.2969,26.4497",
    id: "Fill-943",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8311,23.6895 C38.8311,23.7315 38.8141,23.7775 38.7961,23.8245 C38.8871,23.7805 38.9771,23.7345 39.0681,23.6895 L38.8311,23.6895 Z",
    id: "Fill-945",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0996,26.3882 C24.8046,26.3672 24.5236,26.3412 24.2436,26.3142 C24.2426,26.3362 24.2336,26.3572 24.2336,26.3782 L24.2336,26.5982 C24.5166,26.6312 24.8046,26.6592 25.0996,26.6812 L25.0996,26.3882 Z",
    id: "Fill-947",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7578,24.3506 L16.7578,25.4736 C17.0668,25.6406 17.3978,25.7996 17.7578,25.9456 L17.7578,24.8396 C17.3698,24.6636 17.0338,24.4976 16.7578,24.3506",
    id: "Fill-949",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7578,24.0303 L16.7578,24.3503 C17.0338,24.4973 17.3698,24.6643 17.7578,24.8403 L17.7578,24.7353 C17.2738,24.4863 16.9388,24.2433 16.7578,24.0303",
    id: "Fill-951",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9287,26.7012 L21.9287,26.7012 L21.9287,26.2132 C21.5827,26.1372 21.2477,26.0562 20.9287,25.9702 L20.9287,26.7012 Z",
    id: "Fill-953",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9287,25.8037 L20.9287,25.9697 C21.2477,26.0557 21.5827,26.1367 21.9287,26.2127 L21.9287,26.0047 C21.5777,25.9427 21.2447,25.8747 20.9287,25.8037",
    id: "Fill-955",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0996,26.6816 L25.0996,26.7016 L25.3546,26.7016 L25.3546,26.6966 C25.2706,26.6906 25.1836,26.6876 25.0996,26.6816",
    id: "Fill-957",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-959",
    fill: "#444B68",
    points: "25.4268 26.7012 25.4278 26.7012 25.4298 26.7012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3545,26.6968 L25.3545,26.7008 L25.4275,26.7008 L25.4265,26.7008 C25.4035,26.6988 25.3785,26.6978 25.3545,26.6968",
    id: "Fill-961",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0996,26.4399 C25.8526,26.4299 25.6096,26.4179 25.3716,26.4029 C25.3816,26.5029 25.3936,26.6029 25.4266,26.7009 L25.4296,26.7009 L26.0996,26.7009 L26.0996,26.4399 Z",
    id: "Fill-963",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3545,26.4019 C25.2705,26.3969 25.1825,26.3939 25.0995,26.3879 L25.0995,26.6819 C25.1835,26.6879 25.2705,26.6909 25.3545,26.6969 L25.3545,26.4019 Z",
    id: "Fill-965",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3545,26.4019 L25.3545,26.6969 C25.3785,26.6979 25.4035,26.6989 25.4265,26.7009 C25.3935,26.6029 25.3815,26.5029 25.3725,26.4029 C25.3665,26.4019 25.3605,26.4019 25.3545,26.4019",
    id: "Fill-967",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2715,26.7012 L30.2715,26.7012 L30.2715,26.5072 C29.9335,26.5552 29.6005,26.5942 29.2715,26.6272 L29.2715,26.7012 Z",
    id: "Fill-969",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2715,26.4424 L29.2715,26.6274 C29.6005,26.5944 29.9335,26.5554 30.2715,26.5074 L30.2715,26.3914 C29.9495,26.4134 29.6125,26.4284 29.2715,26.4424",
    id: "Fill-971",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4424,26.7012 L34.4424,26.7012 L34.4424,25.8162 C34.1274,25.8872 33.7914,25.9522 33.4424,26.0142 L33.4424,26.7012 Z",
    id: "Fill-973",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6133,25.9683 C37.9733,25.8243 38.3023,25.6673 38.6133,25.5023 L38.6133,24.1253 C38.6003,24.1243 38.5883,24.1233 38.5753,24.1233 C38.3753,24.3213 38.0553,24.5383 37.6133,24.7613 L37.6133,25.9683 Z",
    id: "Fill-975",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6133,24.0869 C38.6013,24.0989 38.5873,24.1109 38.5753,24.1229 C38.5883,24.1239 38.6003,24.1249 38.6133,24.1249 L38.6133,24.0869 Z",
    id: "Fill-977",
    fill: "#444B68"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-979",
    fill: "#444B68",
    points: "50.3232 32.8521 50.3232 32.8521 50.3232 32.7581 50.3232 32.7581"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-981",
    fill: "#444B68",
    points: "50.3232 32.2485 50.3232 32.2485 50.3232 27.6745 50.3232 27.6755"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-983",
    fill: "#444B68",
    points: "50.3232 27.1655 50.3232 26.3785 50.3232 26.3775"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPrice);
export default __webpack_public_path__ + "static/media/totalPrice.3fdc5791179bc0ccfb6f2c04312dd50f.svg";
export { ForwardRef as ReactComponent };